/* wsapi3-cart-sidebar v1.0 */
/* Deploy Version 2026-10-30 03:32:45 */
/* Deploy Version 2026-09-24 19:11:09 */
/* Deploy Version 2026-07-27 16:11:01 */
wsMain.createModule({
  name: 'cart-drawer',
  version: '1.0',
  updatedAt: '2026-07-14',
  function: 'get',
  // Só busca o preview do carrinho depois que o resto do carregamento crítico da
  // página (banners, produtos, categorias etc.) termina — não é conteúdo acima da
  // dobra, não precisa competir por rede/CPU com o que afeta LCP/CLS.
  onlyAfter: 'all',
  virtualTemplate: { total: [] },
  _lastSelectedFrete: null,
  // true entre o clique em "alterar" e o próximo select/abertura do drawer — faz o
  // refresh() manter o painel de cálculo aberto em vez de re-renderizar a linha
  // "Frete: X" a partir do returnJson.shipping (que agora vem com selected:true
  // persistido, e sem essa trava fecharia o painel no próximo refresh).
  _freteEditing: false,
  // Mesma chave de ofuscação usada em wsapi3-checkout-cart.js (createSharePopup)
  // pro link de compartilhar do carrinho — precisa ser igual pro link gerado
  // aqui bater com o que /carrinho?share_cart=... espera ao ser aberto.
  _shareObfKey: 'kwkbhbvdsojiqwdojr3279tu3qpjawjnvsdjndwopjqwdoh2h9109ejnefj',

  // Chave do snapshot otimista do carrinho (contador/total/itens), escopada por loja — mesmo
  // padrão de 'lastProds' + ApiWS.LV em pagina-produto-personalizado.js. Sem o escopo por loja,
  // duas lojas abertas no mesmo navegador (devkit local, ou o painel testando várias) colidiriam
  // na mesma chave.
  _cartSnapshotKey() {
    return 'wsCartSnapshot_' + ApiWS.LV;
  },

  // Grava o último estado de sucesso (contador, total, itens) junto do cart_token vigente
  // (localStorage['orderIdKeepTC_B'], já usado pelo resto do wsapi3-wsjs.js como identidade do
  // carrinho). O token é o que torna esse cache seguro de reaproveitar como "primeira
  // impressão": ele já é apagado/rotacionado nos momentos em que o carrinho troca de dono —
  // "Limpar Carrinho" (wsapi3-checkout-cart.js), pedido já finalizado (ORDER_ALREADY_PLACED,
  // detectado em ApiWS.Calls.cartPreview/cartView) e logout/sessão expirada
  // (validateAndSync() em wsapi3-wsjs.js) — então só precisa comparar o token salvo contra o
  // atual na leitura; não precisa de nenhum hook extra nesses 3 pontos pra manter isso correto.
  _saveCartSnapshot(returnJson) {
    try {
      const token = (localStorage['orderIdKeepTC_B'] || '').trim();
      if (!token) return; // sem carrinho identificado ainda, não vale a pena cachear

      const items = (returnJson.products || []).map(p => ({
        item_id: p.item_id,
        name: p.name,
        qtd: p.qtd,
        price: p.price,
        photo_url: p.photo_url,
      }));

      localStorage.setItem(wsMain.modules['cart-drawer']._cartSnapshotKey(), JSON.stringify({
        cartToken: token,
        qtdItems: returnJson.qtdItems || 0,
        total: returnJson.total || 0,
        items,
        storedAt: Date.now(),
      }));
    } catch (_) { } // localStorage indisponível/cheio — cache é só otimização, nunca crítico
  },

  // Lê o snapshot (se existir e o cart_token bater com o vigente) e já pinta o contador/estado
  // "vazio" do botão ANTES do fetch de verdade (/cart/preview ou /cart/view, que só roda depois
  // do onlyAfter:"all" resolver — ver timeout em wsapi3-main.js) resolver. refresh() sempre roda
  // por cima depois com o dado real, então isso é só uma primeira impressão, nunca a fonte da
  // verdade — se o token não bater (carrinho trocou de dono) ou não existir cache, não pinta
  // nada, mantém o comportamento de hoje (contador vazio até o fetch real voltar).
  _paintFromCachedSnapshot() {
    try {
      const raw = localStorage.getItem(wsMain.modules['cart-drawer']._cartSnapshotKey());
      if (!raw) return;

      const snapshot = JSON.parse(raw);
      const currentToken = (localStorage['orderIdKeepTC_B'] || '').trim();
      if (!currentToken || snapshot.cartToken !== currentToken) return;

      const counter = document.querySelector('[data-wsjs-cart="counter"]');
      if (counter) counter.innerHTML = snapshot.qtdItems || 0;

      const btn = document.querySelector('[data-wsjs-cart="button"]');
      if (btn) btn.classList.toggle('cart-empty', !snapshot.qtdItems);
    } catch (_) { } // JSON inválido ou localStorage indisponível — não pinta nada, sem crash
  },

  async get(useFullDetails = false) {
    if (!wsMain.modules['cart-drawer']._keyboardBound) {
      wsMain.modules['cart-drawer']._keyboardBound = true;
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (wsMain.modules['cart-drawer']._giftDialog?.open) return;
        if (wsMain.modules['cart-drawer']._cleanDialog?.open) return;
        const overlay = document.querySelector('[data-wsjs-cart="overlay-holder"]');
        if (overlay?.style.width === '100%') wsMain.modules['cart-drawer'].changeState();
      });
    }

    wsMain.modules['cart-drawer']._bindExtras();
    wsMain.modules['cart-drawer']._paintFromCachedSnapshot();

    const mod = wsMain.modules['cart-drawer'];
    // Com o drawer aberto, qualquer refresh usa o /cart/view completo — um
    // get(false) de fundo (carregamento inicial com onlyAfter:"all", ou o
    // disparado pela sidebar "Adicionado") re-renderizaria sem subtotal,
    // sugestões e preços à vista/parcelado.
    if (!useFullDetails && document.querySelector('[data-wsjs-cart="button"]')?.getAttribute('cart-state') === 'true') {
      useFullDetails = true;
    }
    // Só a resposta da chamada mais recente renderiza — uma mais antiga que
    // volte depois (ex.: preview lento) não sobrescreve a mais nova.
    const seq = mod._getSeq = (mod._getSeq || 0) + 1;

    const normalized = useFullDetails
      ? await mod._fetchFullDetails()
      : await mod._fetchPreview();

    if (seq !== mod._getSeq) return true;

    console.log('[CartDrawer] normalized:', { full: useFullDetails, products: normalized.products?.length, total: normalized.total, qtdItems: normalized.qtdItems });
    const refreshed = await wsMain.modules['cart-drawer'].refresh(normalized);
    // Sem await: reabre o carrinho depois de um login vindo do link do cupom.
    mod._resumeCouponAfterLogin();
    return refreshed;
  },

  /* ─────────────────────────────────────────────
     CONFIG OPCIONAL DA PÁGINA — ocultar partes do carrinho lateral / sidebar
     "Adicionado ao carrinho". A loja declara no <head> um objeto global:

       let sidebarCart = {           // ou  window.sidebarCart = { ... }
         compartilhar: false,        // botão/menu de compartilhar carrinho
         sugeridos:    false,        // bloco "Sugestões pra você" / "Produtos recomendados"
         brindes:      false,        // bloco "Brindes"
         frete:        false,        // bloco "Frete" (cálculo por CEP)
         cupom:        false,        // bloco "Cupom"
         linkCarrinho: true,         // link "Ver carrinho" (oculto por padrão)
         cleanbutton:  true,         // ícone de lixeira "Limpar carrinho" ao lado do compartilhar
         mainprice:    'cash',       // preço principal: 'normal' (padrão) | 'cash' | 'credit'
         cashprice_tag: 'à vista',   // texto da tag ao lado do preço à vista (padrão: 'PIX')

         // Quais preços exibir em cada lugar (ver _priceCfg / _priceBlockHtml):
         cartitems:     { normalprice: false, cashprice: true, creditprice: false }, // itens do carrinho
         recomenditems: { normalprice: false, cashprice: true, creditprice: false }, // sugestões / recomendados
         resumevalues:  { total: true, cashprice: true, creditprice: true },         // rodapé (total do pedido)
       };

     As 5 primeiras chaves só OCULTAM quando valem exatamente `false`. Ausente,
     `true` ou qualquer outro valor = visível.
     `linkCarrinho` e `cleanbutton` são o contrário — opt-in: só aparecem com
     exatamente `true` (sem o objeto, ou sem a chave, ficam ocultos).

     Grupos de preço: sem o objeto (ou sem a chave), o padrão é
     normalprice/total = true e cashprice/creditprice = false — ou seja, o
     comportamento de sempre. normalprice/total só some com `false`;
     cashprice/creditprice só aparecem com `true`. Se o preço normal/total foi
     desligado mas o à vista não se aplica (loja/item sem desconto à vista, ou
     ainda sem os dados do /cart/view), o preço normal/total volta como
     fallback — nunca fica sem preço principal.

     `mainprice` / `cashprice_tag` valem pros 3 grupos; um grupo pode
     sobrescrever com a própria chave (ex.: resumevalues: { mainprice:'normal' }).
     Estilo (ver CSS .cd-price-*): o principal fica 14px negrito; o normal,
     quando não é o principal, fica riscado 12px; o parcelado não-principal,
     12px; o à vista não-principal, 14px normal. Se o `mainprice` pedido não
     estiver ligado ou não se aplicar (ex.: 'cash' sem desconto), o normal
     assume como principal (e aparece, mesmo com normalprice:false).

     É lido a cada abertura/refresh do drawer, então dá pra alternar em runtime
     também. Quando um bloco está oculto, a chamada de API que o alimenta
     (sugestões) nem é feita.

     Afeta SÓ o carrinho lateral — exceto `recomenditems`, que também vale pros
     "Produtos recomendados" da sidebar de confirmação de inserção
     (#ws-added-sidebar). Fora isso ela ignora esse objeto de propósito —
     inclusive o "Ver carrinho" dela continua visível mesmo sem linkCarrinho:true.
  ───────────────────────────────────────────── */
  _pageConfig() {
    let cfg = null;
    try { if (typeof sidebarCart !== 'undefined' && sidebarCart) cfg = sidebarCart; } catch (e) {}
    if (!cfg && typeof window !== 'undefined') cfg = window.sidebarCart;
    return (cfg && typeof cfg === 'object') ? cfg : {};
  },

  _cfgHidden(key) {
    return wsMain.modules['cart-drawer']._pageConfig()[key] === false;
  },

  _cfgOn(key) {
    return wsMain.modules['cart-drawer']._pageConfig()[key] === true;
  },

  /* ─────────────────────────────────────────────
     PREÇOS (sidebarCart.cartitems / recomenditems / resumevalues)
     `rules` = { cashPercent, max, interest, interestStart, min } — mesma
     semântica dos campos normalizados de produto (precos.desconto_avista /
     max_parcelas / juros / juros_inicia / valor_min_parcelas). O cálculo de
     parcela é o mesmo de wsapi3-prod-template-rules (card da listagem), só
     que escondendo "1x" (não agrega nada ao preço já exibido).
  ───────────────────────────────────────────── */
  _installmentLabel(value, rules) {
    const max = Number(rules?.max) || 0;
    const interest = Number(rules?.interest) || 0;
    const interestStart = Number(rules?.interestStart) || 0;
    const min = Number(rules?.min) || 0;
    if (max <= 1 || !(value > 0)) return '';

    const fee = n => wsMain.data.compostFeeValue(interest, n, interestStart, value);
    let n = 0, v = value;

    // 1º tenta a maior parcela sem juros; se não sobrar mais de 1x, cai pra com juros.
    if (interest > 0 && interestStart > 0) {
      n = interestStart < max ? interestStart - 1 : max;
      v = fee(n);
      while (n > 1 && v < min) { n--; v = fee(n); }
    }
    if (n <= 1) {
      n = max;
      v = fee(n);
      while (n > 1 && v < min) { n--; v = fee(n); }
    }
    if (n <= 1) return '';

    const withInterest = interest > 0 && n >= interestStart;
    return `${n}x de ${wsMain.data.treatPrice(v)}${withInterest ? '' : ' sem juros'}`;
  },

  // { normal, cash, credit, main, tag } de um grupo do sidebarCart. `normalKey`
  // é 'normalprice' (itens/recomendados) ou 'total' (resumevalues). main/tag:
  // chave do grupo > chave global > padrão ('normal' / 'PIX').
  _priceCfg(group, normalKey = 'normalprice') {
    const all = wsMain.modules['cart-drawer']._pageConfig();
    const g = all[group];
    const o = (g && typeof g === 'object') ? g : {};
    const main = o.mainprice ?? all.mainprice;
    const tag = o.cashprice_tag ?? all.cashprice_tag;
    return {
      normal: o[normalKey] !== false,
      cash:   o.cashprice === true,
      credit: o.creditprice === true,
      main:   ['normal', 'cash', 'credit'].includes(main) ? main : 'normal',
      tag:    (typeof tag === 'string' && tag.trim()) ? tag.trim() : 'PIX',
    };
  },

  // Decide o que aparece e qual é o principal. Principal pedido que não está
  // ligado/não se aplica → normal assume (e aparece mesmo com normal:false).
  _resolvePriceLines(cfg, hasCash, hasCredit) {
    const cash = cfg.cash && hasCash;
    const credit = cfg.credit && hasCredit;
    let main = cfg.main;
    if ((main === 'cash' && !cash) || (main === 'credit' && !credit)) main = 'normal';
    // Sem nenhum preço visível (normal:false e nada mais se aplica) → normal.
    if (!cfg.normal && !cash && !credit) main = 'normal';
    return { normal: cfg.normal || main === 'normal', cash, credit, main };
  },

  _escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  },

  _cashTagHtml(cfg) {
    return `<span class="cd-price-tag">${wsMain.modules['cart-drawer']._escapeHtml(cfg.tag)}</span>`;
  },

  // Linhas de preço de um item/recomendado. `cashValue` = null quando o à
  // vista não se aplica; `installment` = rótulo pronto ('' = não se aplica).
  // `normalHtml` = markup do preço normal (permite o "de/por" das sugestões).
  _priceBlockHtml(cfg, { normalHtml, cashValue, installment }) {
    const mod = wsMain.modules['cart-drawer'];
    const r = mod._resolvePriceLines(cfg, cashValue != null, !!installment);
    let html = '';
    if (r.normal) html += `<span class="cd-price-normal ${r.main === 'normal' ? 'cd-price-main' : 'cd-price-struck'}">${normalHtml}</span>`;
    if (r.cash) html += `<span class="cd-price-cash${r.main === 'cash' ? ' cd-price-main' : ''}"><span>${wsMain.data.treatPrice(cashValue)}</span>${mod._cashTagHtml(cfg)}</span>`;
    if (r.credit) html += `<span class="cd-price-installment${r.main === 'credit' ? ' cd-price-main' : ''}">${r.main === 'credit' ? '' : 'ou '}${installment}</span>`;
    return html;
  },

  _cashValue(value, pct) {
    pct = Number(pct) || 0;
    return (value > 0 && pct > 0) ? value * (100 - pct) / 100 : null;
  },

  // HTML de preço de um produto normalizado (sugestões do drawer e
  // recomendados da #ws-added-sidebar) — grupo recomenditems.
  _suggestionPriceHtml(p) {
    const mod = wsMain.modules['cart-drawer'];
    const preco      = p.precos?.preco || 0;
    const promocao   = p.precos?.preco_promocao || 0;
    const hasPromo   = promocao > 0 && promocao < preco;
    const finalPrice = hasPromo ? promocao : preco;
    const cfg = mod._priceCfg('recomenditems');
    const rules = mod._productPriceRules(p.precos);
    return mod._priceBlockHtml(cfg, {
      normalHtml: `${hasPromo ? `<span class="cd-suggestion-item__price-old">${wsMain.data.treatPrice(preco)}</span> ` : ''}<span class="cd-suggestion-item__price">${wsMain.data.treatPrice(finalPrice)}</span>`,
      cashValue: rules ? mod._cashValue(finalPrice, rules.cashPercent) : null,
      installment: (cfg.credit && rules) ? mod._installmentLabel(finalPrice, rules) : '',
    });
  },

  // Soma dos itens com o desconto à vista aplicado só nos elegíveis
  // (cash_price_apply, sem brinde) — null quando não há desconto aplicável.
  _cashItemsSum(returnJson, base) {
    const pct = Number(returnJson.priceRules?.cashPercent) || 0;
    if (!(pct > 0)) return null;
    const eligible = Math.min(base, (returnJson.products || [])
      .filter(p => !p.isGift && p.cashApply)
      .reduce((sum, p) => sum + (Number(p.price) || 0) * (Number(p.qtd) || 0), 0));
    return eligible > 0 ? base - eligible * pct / 100 : null;
  },

  // Subtotal do resumo: com resumevalues.mainprice = 'cash' (e à vista
  // aplicável), o subtotal normal fica riscado e a soma à vista vem ao lado,
  // com a tag — mesmo visual do total no rodapé.
  _renderSubtotal(el, returnJson) {
    const mod = wsMain.modules['cart-drawer'];
    const subtotal = Number(returnJson.subtotal) || 0;
    const cfg = mod._priceCfg('resumevalues', 'total');
    const cashSum = mod._cashItemsSum(returnJson, subtotal);
    const r = mod._resolvePriceLines(cfg, cashSum != null, false);
    if (r.main !== 'cash') {
      el.textContent = wsMain.data.treatPrice(subtotal);
      return;
    }
    el.innerHTML = `<span class="cd-subtotal-cash"><s class="cd-price-struck">${wsMain.data.treatPrice(subtotal)}</s>`
      + `<b>${wsMain.data.treatPrice(cashSum)}</b>${mod._cashTagHtml(cfg)}</span>`;
  },

  // Rodapé: total / à vista / parcelado (grupo resumevalues). À vista = mesma
  // conta do "no boleto ou PIX" da /carrinho (createBoletoPixDiscount): o
  // desconto incide só sobre os itens com cash_price_apply, frete fora.
  _renderResumeValues(returnJson, hasProducts) {
    const mod = wsMain.modules['cart-drawer'];
    const holder = document.querySelector('[data-wsjs-cart="holder"]');
    const totalEl = holder?.querySelector('.cd-footer-total[data-wsjs-cart="total"]');
    const extras = holder?.querySelector('[data-wsjs-cart="resume-extras"]');
    if (!extras) return;

    const cfg = mod._priceCfg('resumevalues', 'total');
    const rules = returnJson.priceRules;
    let cashValue = null, installment = '';

    if (hasProducts && rules) {
      const total = Number(returnJson.total) || 0;
      const ship = returnJson.shipping?.selected ? (Number(returnJson.shipping.price) || 0) : 0;
      const cashBase = mod._cashItemsSum(returnJson, Math.max(0, total - ship));
      if (cashBase != null) cashValue = cashBase + ship;
      if (cfg.credit) installment = mod._installmentLabel(total, rules);
    }

    const r = mod._resolvePriceLines(cfg, cashValue != null, !!installment);
    if (totalEl) {
      totalEl.classList.toggle('cd-cfg-hidden', !r.normal);
      totalEl.classList.toggle('cd-price-struck', r.main !== 'normal');
    }

    // Sem a linha do total, o rótulo "Total:" passa pro principal.
    const label = r.normal ? '' : '<span>Total:</span> ';
    let html = '';
    if (r.cash) html += `<div class="cd-footer-total cd-footer-cash${r.main === 'cash' ? ' cd-price-main' : ''}">${r.main === 'cash' ? label : ''}<b>${wsMain.data.treatPrice(cashValue)}</b>${mod._cashTagHtml(cfg)}</div>`;
    if (r.credit) html += `<div class="cd-footer-installment${r.main === 'credit' ? ' cd-price-main' : ''}">${r.main === 'credit' ? label : 'ou '}${installment}</div>`;
    extras.innerHTML = html;
  },

  // Regras de preço de um produto normalizado (sugestões / recomendados).
  _productPriceRules(precos) {
    if (!precos) return null;
    return {
      cashPercent:   precos.desconto_avista,
      max:           precos.max_parcelas,
      interest:      precos.juros,
      interestStart: precos.juros_inicia,
      min:           precos.valor_min_parcelas,
    };
  },

  _applyPageConfig() {
    const mod = wsMain.modules['cart-drawer'];
    // Prefixado com [data-wsjs-cart="holder"] pra NUNCA atingir a #ws-added-sidebar
    // (que usa data-added-* e também tem uma .cd-goto-cart-link própria).
    const toggle = (sel, key) => {
      document.querySelectorAll(`[data-wsjs-cart="holder"] ${sel}`)
        .forEach(el => el.classList.toggle('cd-cfg-hidden', mod._cfgHidden(key)));
    };
    toggle('[data-wsjs-cart="share-wrap"]', 'compartilhar');
    toggle('[data-wsjs-cart="suggestions"]', 'sugeridos');
    toggle('[data-wsjs-cart="gifts"]', 'brindes');
    toggle('[data-wsjs-cart="frete-block"]', 'frete');
    toggle('[data-wsjs-cart="cupom-block"]', 'cupom');
    // opt-in: oculto a menos que linkCarrinho === true (nasce com cd-cfg-hidden no HTML)
    document.querySelectorAll('[data-wsjs-cart="holder"] .cd-goto-cart-link')
      .forEach(el => el.classList.toggle('cd-cfg-hidden', !mod._cfgOn('linkCarrinho')));
    // opt-in: oculto a menos que cleanbutton === true
    document.querySelectorAll('[data-wsjs-cart="holder"] [data-wsjs-cart="clean"]')
      .forEach(el => el.classList.toggle('cd-cfg-hidden', !mod._cfgOn('cleanbutton')));
  },

  async _fetchPreview() {
    // Chamada leve (/cart/preview) — usada no carregamento da página e em
    // atualizações de fundo. Não traz cupom/subtotal/desconto detalhados.
    const data = await ApiWS.Calls.carrinho();
    console.log('[CartDrawer] cart/preview raw response:', data);
    return {
      products: data.products || (data.records || []).map(p => ({
        ...p,
        photo_url: p.photo_url || p.image,
        qtd:       p.qtd       || p.quantity,
        item_id:   p.item_id,
        group_id:  p.group_id  || '',
      })),
      total:                 data.total                ?? data.record?.total                ?? 0,
      qtdItems:              data.qtdItems             ?? data.record?.item_count            ?? 0,
      link:                  data.link                 || data.record?.cart_url              || '/carrinho',
      freeShippingThreshold: data.record?.free_shipping_threshold || 0,
      hasCoupon:    false,
      acceptCoupon: true,
      sendable:     true,
      subtotal:     null,
      discount:     null,
      cupom:        null,
      shipping:     null,
      isFull:       false,
    };
  },

  async _fetchFullDetails() {
    // Chamada completa (/cart/view) — usada ao abrir o drawer, traz os
    // mesmos dados do carrinho oficial (subtotal, desconto, cupom, frete).
    const data = await ApiWS.Calls.cartView();
    console.log('[CartDrawer] cart/view raw response:', data);

    // Publica o cart bruto em window.cartJson — é o que o gift-slider
    // (wsapi3-checkout-cart.js) e ApiWS.Calls.listProducts.suggestion() esperam encontrar
    // pra funcionar. Fora da página /carrinho (onde o próprio checkout-cart
    // já faz isso) ninguém mais preenchia essa variável, então brindes e
    // sugestões nunca apareciam no drawer das outras páginas.
    window.cartJson = data;

    const products = (data.products || []).map(p => ({
      photo_url:  p.photo,
      qtd:        p.quantity,
      item_id:    p.itemId,
      group_id:   p.groupId || '',
      product_id: p.productId,
      sku:        p.sku ? String(p.sku).trim() : '',
      price:      p.real_price,
      // Preço "DE" (cheio) do item em promoção — /cart/view traz original_price
      // ao lado de real_price; só vale quando maior que o preço de venda.
      originalPrice: Number(p.original_price) > Number(p.real_price) ? Number(p.original_price) : 0,
      name:       p.name,
      url:        p.url,
      isGift:     !!p.storeGift,
      // Item elegível ao desconto à vista (cash_discount do carrinho) — mesma
      // regra de wsapi3-checkout-cart.js (getCashDiscountEligibleTotal).
      cashApply:  p.cash_price_apply === true,
      // Cashback e embrulho pra presente — mesmos campos que wsapi3-checkout-cart.js
      // usa (prod.cashback.valor / prod.gift_packaging.{active,amount,status}).
      cashback:   p.cashback?.valor || 0,
      giftWrap:   p.gift_packaging?.active
        ? { amount: p.gift_packaging.amount || 0, checked: !!p.gift_packaging.status }
        : null,
      attributes: (p.add_info || []).map(a => ({ type: a.title, value: a.value })),
    }));

    return {
      products,
      gifts:                 Array.isArray(data.gifts) ? data.gifts : [],
      total:                 data.total ?? 0,
      qtdItems:              products.reduce((sum, p) => sum + (Number(p.qtd) || 0), 0),
      link:                  data.cart_url || '/carrinho',
      // Nunca confirmado contra a API real (não existe "free_shipping_threshold"
      // na doc do Postman) — tentamos alguns nomes plausíveis, mas o log de
      // debug em _renderFreteGratisAlert (que imprime `data` cru mais acima,
      // em "cart/view raw response") é a fonte de verdade pra achar o campo
      // certo, se houver algum.
      freeShippingThreshold: data.free_shipping_threshold || data.record?.free_shipping_threshold || 0,
      hasCoupon:    Boolean(data.cupom?.code),
      acceptCoupon: data.accept_coupon !== false,
      sendable:     data.sendable !== false,
      subtotal:     data.subtotal,
      discount:     data.discount,
      cupom:        data.cupom || null,
      shipping:     data.shipping || null,
      // Regras do carrinho pro preço à vista/parcelado de cada item
      // (sidebarCart.cashprice/creditprice). Parcela sem juros até
      // max_installments_no_interest — mesmo mapeamento de wsapi3-checkout-cart.js.
      priceRules: {
        cashPercent:   Number(data.cash_discount) || 0,
        max:           Number(data.max_installments) || 0,
        interest:      Number(data.installments_interest) || 0,
        interestStart: (Number(data.max_installments_no_interest) || 0) + 1,
        min:           Number(data.installments_min_value) || 0,
      },
      isFull:       true,
    };
  },

  async refresh(returnJson) {
    const btn          = document.querySelector('[data-wsjs-cart="button"]');
    const itensHolder  = document.querySelector('[data-wsjs-cart="items-holder"]');
    console.log('[CartDrawer] refresh | btn:', !!btn, '| itensHolder:', !!itensHolder);
    if (!btn || !itensHolder) {
      console.warn('[CartDrawer] refresh abortado: elementos do drawer ausentes no DOM desta página');
      return true;
    }
    wsMain.modules['cart-drawer']._prefillCep();

    const btnOptions   = wsMain.tools.getWsData(btn, 'options');
    const defaultMsg   = document.querySelector('[data-wsjs-cart="default-message"]');
    // .total-holder é único no drawer (o outro elemento com data-wsjs-cart="total"
    // é .cd-footer-total, dentro do rodapé) — seletor por classe, não por
    // profundidade no DOM, pra não depender de onde .total-holder está aninhado.
    const totalInCart  = document.querySelector('.total-holder')
                      || document.querySelector('.mobile-menu-side [data-wsjs-cart="total"]');
    const bottomMsg    = document.querySelector('[data-wsjs-cart="bottom-message"]');
    console.log('[CartDrawer] refresh | defaultMsg:', !!defaultMsg, '| bottomMsg:', !!bottomMsg, '| products:', returnJson.products?.length);

    // href="/checkout" fica só de fallback (ex: JS falhar) — a navegação de
    // verdade é via _bindCheckoutButton, que chama /cart/close primeiro (ver
    // mais abaixo) e só então redireciona com os tokens que essa chamada
    // retorna, igual o botão "Finalizar compra" do carrinho completo.
    document.querySelectorAll('[data-wsjs-cart="link"]')
      .forEach(el => el.setAttribute('href', '/checkout'));

    document.querySelectorAll('[data-wsjs-cart="total"]').forEach((el, i) => {
      if (el.innerHTML.indexOf('{{value}}') !== -1)
        wsMain.modules['cart-drawer'].virtualTemplate.total[i] = el.innerHTML;

      // Se este índice nunca chegou a ter "{{value}}" capturado (ex: innerHTML
      // já veio sem o placeholder na primeira passagem), não dá pra montar o
      // template — pula esse elemento em vez de estourar e abortar o forEach
      // (o que deixaria os itens seguintes do NodeList sem ser processados).
      const template = wsMain.modules['cart-drawer'].virtualTemplate.total[i];
      if (template) {
        el.innerHTML = template.replace('{{value}}', wsMain.data.treatPrice(returnJson.total));
      }
      try { el.style.opacity = ''; } catch(e) {}
      try { wsMain.addons.dataLoad(el); } catch(e) {}
    });

    // remove rendered items, keep the original <template>
    itensHolder.querySelectorAll(':scope > *:not([data-wsjs-cart="template"])')
      .forEach(el => el.remove());

    const hasProducts = Array.isArray(returnJson?.products) && returnJson.products.length > 0;
    wsMain.modules['cart-drawer']._syncGiftPrompt(returnJson);

    // Carrinho vazio: só título + fechar + "carrinho vazio" — nada de
    // compartilhar, subtotal, sugestões ou brindes.
    const shareWrap = document.querySelector('[data-wsjs-cart="share-wrap"]');
    if (shareWrap) shareWrap.style.display = hasProducts ? '' : 'none';
    const cleanBtn = document.querySelector('[data-wsjs-cart="holder"] [data-wsjs-cart="clean"]');
    if (cleanBtn) cleanBtn.style.display = hasProducts ? '' : 'none';

    if (hasProducts) {
      defaultMsg.setAttribute('style', 'display:none;');
      totalInCart?.removeAttribute('style');
      itensHolder.classList.add('cartHasItens');

      returnJson.products.forEach(prod => {
        const varsHtml = (prod.attributes || [])
          .filter(a => a?.type && a?.value)
          .map(a => `<span class="cart-item-variation">${a.type}: ${a.value}</span>`)
          .join('');

        // Presente (embrulho) e cashback só fazem sentido pra item de venda
        // normal, não pra brinde (isGift) — mesma regra de
        // wsapi3-checkout-cart.js (createProds, campos !isGift).
        const giftWrapHtml = (!prod.isGift && prod.giftWrap) ? `
          <label class="cart-item-giftwrap">
            <input type="checkbox" class="cart-item-giftwrap-input" ${prod.giftWrap.checked ? 'checked' : ''}>
            <span>Para presente (+${wsMain.data.treatPrice(prod.giftWrap.amount)})</span>
          </label>` : '';

        const cashbackHtml = (!prod.isGift && prod.cashback > 0) ? `
          <div class="cart-item-cashback">${wsMain.data.treatPrice(prod.cashback)} em cashback</div>` : '';

        // Preço da linha (grupo cartitems) — à vista/parcelado só no /cart/view
        // (priceRules), sobre o total da linha. À vista só se o item aceitar
        // o desconto (cash_price_apply); senão cai no preço normal.
        const mod = wsMain.modules['cart-drawer'];
        const lineTotal = prod.price * prod.qtd;
        const rules = (!prod.isGift && returnJson.priceRules) ? returnJson.priceRules : null;
        const priceCfg = mod._priceCfg('cartitems');
        const priceHtml = mod._priceBlockHtml(priceCfg, {
          // DE riscado (fonte normal) à esquerda + preço de venda ao lado, como hoje.
          normalHtml: `${(!prod.isGift && prod.originalPrice) ? `<span class="cd-price-old">${wsMain.data.treatPrice(prod.originalPrice * prod.qtd)}</span> ` : ''}<span>${wsMain.data.treatPrice(lineTotal)}</span>`,
          cashValue: (rules && prod.cashApply) ? mod._cashValue(lineTotal, rules.cashPercent) : null,
          installment: (priceCfg.credit && rules) ? mod._installmentLabel(lineTotal, rules) : '',
        });

        const item = document.createElement('div');
        item.className = 'cart-item-holder';
        // Item com estoque zerado (cart/view devolve quantity 0) — linha
        // esmaecida pro cliente ver que tem problema ali (ver .cd-item-oos no CSS).
        if (Number(prod.qtd) === 0) item.classList.add('cd-item-oos');
        item.dataset.itemId    = prod.item_id;
        item.dataset.groupId   = prod.group_id || '';
        item.dataset.productId = prod.product_id || '';
        item.dataset.price     = prod.price || 0;

        item.innerHTML = `
          <a href="${prod.url || '#'}" class="cart-item-img">
            <img src="${prod.photo_url || ''}" alt="${prod.name || ''}" loading="lazy">
          </a>
          <div class="cart-item-body">
            <div class="cart-item-row-top">
              <a href="${prod.url || '#'}" class="cart-item-name">${prod.name || ''}</a>
              <button class="cart-remove-btn" type="button" title="Remover item">
                <span data-wsjs-icon="delete"></span>
              </button>
            </div>
            ${varsHtml ? `<div class="cart-item-variations">${varsHtml}</div>` : ''}
            <div class="cart-item-row-qty">
              <div class="cart-item-qty">
                <button class="cart-qty-btn cart-qty-sub" type="button">&#8722;</button>
                <input  class="cart-qty-input" type="text" value="${prod.qtd}" maxlength="3">
                <button class="cart-qty-btn cart-qty-add" type="button">&#43;</button>
              </div>
              <div class="cart-item-price cd-price-block">${priceHtml}</div>
            </div>
            ${giftWrapHtml}
            ${cashbackHtml}
          </div>`;

        itensHolder.append(item);
      });

      wsMain.modules['cart-drawer']._bindEvents(itensHolder);
      // awaited (não fire-and-forget) — junto com _renderSuggestions/_renderGifts
      // mais abaixo, é o que faz o loading (ver changeState) só sumir depois
      // que TUDO já está pronto, sem o conteúdo "pipocando" aos poucos.
      await wsMain.modules['cart-drawer']._renderFreteGratisAlert(returnJson, bottomMsg);
      bottomMsg.removeAttribute('style');

    } else {
      if (btnOptions.float === true)
        document.querySelector('.cart-holder .cart-default-message a')?.style.setProperty('display', 'none');

      defaultMsg.removeAttribute('style');
      totalInCart ? totalInCart.style.display = 'none' : null;
      itensHolder.classList.remove('cartHasItens');
      bottomMsg.setAttribute('style', 'display:none;');
      document.querySelector('[data-wsjs-frete-gratis]')?.remove();
    }

    // resumo (subtotal / desconto / cupom) — só vem preenchido no fetch completo (/cart/view)
    const resumo = document.querySelector('[data-wsjs-cart="resumo"]');
    if (resumo) {
      if (returnJson.subtotal != null && hasProducts) {
        resumo.style.display = '';
        const subtotalEl = resumo.querySelector('[data-wsjs-cart="resumo-subtotal"]');
        if (subtotalEl) wsMain.modules['cart-drawer']._renderSubtotal(subtotalEl, returnJson);

        const discountLine = resumo.querySelector('[data-wsjs-cart="resumo-discount-line"]');
        const discountEl   = resumo.querySelector('[data-wsjs-cart="resumo-discount"]');
        // /cart/view.discount já inclui o cupom (que tem linha própria logo
        // abaixo) — aqui só o restante, senão o valor do cupom aparece 2x.
        const otherDiscount = Math.round(((Number(returnJson.discount) || 0)
          - (returnJson.cupom?.code ? (Number(returnJson.cupom.amount) || 0) : 0)) * 100) / 100;
        if (otherDiscount > 0) {
          if (discountLine) discountLine.style.display = '';
          if (discountEl) discountEl.textContent = `- ${wsMain.data.treatPrice(otherDiscount)}`;
        } else if (discountLine) {
          discountLine.style.display = 'none';
        }

        const cupomLine  = resumo.querySelector('[data-wsjs-cart="resumo-cupom-line"]');
        const cupomLabel = resumo.querySelector('[data-wsjs-cart="resumo-cupom-label"]');
        const cupomValue = resumo.querySelector('[data-wsjs-cart="resumo-cupom-value"]');
        if (returnJson.cupom?.code) {
          if (cupomLine) cupomLine.style.display = '';
          if (cupomLabel) cupomLabel.textContent = `Cupom ${returnJson.cupom.name || returnJson.cupom.code}`;
          if (cupomValue) cupomValue.textContent = `- ${wsMain.data.treatPrice(returnJson.cupom.amount || 0)}`;
        } else if (cupomLine) {
          cupomLine.style.display = 'none';
        }
      } else {
        resumo.style.display = 'none';
      }
    }

    const cupomBlock = document.querySelector('[data-wsjs-cart="cupom-block"]');
    if (cupomBlock) cupomBlock.style.display = returnJson.acceptCoupon === false ? 'none' : '';

    // cupom/frete só têm o estado "selecionado" resolvido no fetch completo (/cart/view);
    // no fetch leve (/cart/preview) mantém o que já estava exibido.
    if (returnJson.isFull) {
      if (hasProducts) {
        await Promise.all([
          wsMain.modules['cart-drawer']._renderSuggestions(),
          wsMain.modules['cart-drawer']._renderGifts(returnJson),
        ]);
      } else {
        document.querySelector('[data-wsjs-cart="suggestions"]')?.style.setProperty('display', 'none');
        document.querySelector('[data-wsjs-cart="gifts"]')?.style.setProperty('display', 'none');
      }

      const cupomToggle   = document.querySelector('[data-wsjs-cart="cupom-toggle"]');
      const cupomContent  = document.querySelector('[data-wsjs-cart="cupom-content"]');
      const cupomSelected = document.querySelector('[data-wsjs-cart="cupom-selected"]');
      if (cupomToggle && cupomContent && cupomSelected) {
        if (returnJson.hasCoupon) {
          cupomToggle.style.display  = 'none';
          cupomContent.style.display = 'none';
          cupomSelected.style.display = '';
          const label = cupomSelected.querySelector('[data-wsjs-cart="cupom-selected-label"]');
          if (label) label.textContent = `Cupom: -${wsMain.data.treatPrice(returnJson.cupom?.amount || 0)}`;
        } else {
          cupomSelected.style.display = 'none';
          if (cupomToggle.style.display === 'none') cupomToggle.style.display = '';
        }
      }

      // Multi CD: alterar o carrinho apaga a alocação por CD e o frete
      // escolhido (ApiWS.Calls.cartItem* limpa ApiWS.MultiCd) — recalcula e
      // pede nova escolha por pacote.
      const cdMod = wsMain.modules['cart-drawer'];
      if (cdMod._multiCd && !ApiWS.MultiCd.last() && hasProducts) {
        cdMod._multiCd = null;
        cdMod._lastSelectedFrete = null;
        setTimeout(() => cdMod._reopenFrete(), 0);
      }

      const freteToggle   = document.querySelector('[data-wsjs-cart="frete-toggle"]');
      const freteContent  = document.querySelector('[data-wsjs-cart="frete-content"]');
      const freteSelected = document.querySelector('[data-wsjs-cart="frete-selected"]');
      if (freteToggle && freteContent && freteSelected) {
        // A API persiste o frete escolhido no /cart/view (bloco `shipping`) desde
        // 29/08 — `selected/name/isFree/deadline/price` vêm completos. `deadline` é
        // número (ex: 1) e `price` vem em reais (ex: 16.9 — até 09/2026 vinha em centavos); não há
        // `deadline_display`/`price_display`. Mantemos `_lastSelectedFrete` (setado
        // no clique, em _selecionarFrete) como fonte preferida só pra pintar a linha
        // instantaneamente, sem esperar o re-fetch — o apiSelected cobre o reload.
        const lastSelected = wsMain.modules['cart-drawer']._lastSelectedFrete;
        const s = returnJson.shipping;
        const apiSelected = s?.selected
          ? {
              name: s.name || 'Frete',
              deadline: wsMain.modules['cart-drawer']._deadlineLabel({ deadline: Number(s.deadline) }),
              priceLabel: (s.isFree || Number(s.price) === 0)
                ? 'Grátis'
                : wsMain.data.treatPrice(Number(s.price || 0)),
            }
          : null;
        const freteInfo = wsMain.modules['cart-drawer']._freteEditing ? null : (lastSelected || apiSelected);

        if (freteInfo) {
          freteToggle.style.display  = 'none';
          freteContent.style.display = 'none';
          freteSelected.style.display = '';
          const label = freteSelected.querySelector('[data-wsjs-cart="frete-selected-label"]');
          if (label) {
            // Só prazo e preço — sem o "Frete: <nome do método>" (o método já
            // aparece na lista ao clicar em "alterar"; aqui é redundante).
            label.innerHTML = `${freteInfo.deadline ? freteInfo.deadline + ' &mdash; ' : ''}${freteInfo.priceLabel}`;
          }
        } else {
          // Não força o fechamento se o usuário já deixou o painel aberto
          // manualmente (ex.: clicou em "alterar") — só garante que o
          // toggle esteja visível.
          freteSelected.style.display = 'none';
          if (freteToggle.style.display === 'none') freteToggle.style.display = '';
        }
      }
    }

    const freteBlock = document.querySelector('[data-wsjs-cart="frete-block"]');
    if (freteBlock) freteBlock.style.display = returnJson.sendable === false ? 'none' : '';

    const counter = document.querySelector('[data-wsjs-cart="counter"]');
    if (counter) counter.innerHTML = returnJson?.qtdItems || 0;

    wsMain.modules['cart-drawer']._saveCartSnapshot(returnJson);

    if (btnOptions.float !== true) {
      if (typeof nPanel === 'undefined' && !btn.dataset.cartBound) {
        btn.dataset.cartBound = '1';
        btn.addEventListener('click', () => wsMain.modules['cart-drawer'].changeState());
      }
      wsMain.modules['cart-drawer']._moveDrawerToBody();
    } else {
      document.querySelector('[data-wsjs-cart="holder"]').classList.add('float');
      btn.setAttribute('href', '/carrinho');
    }

    const holder = document.querySelector('[data-wsjs-cart="holder"]');
    if (!returnJson.qtdItems || returnJson.qtdItems === 0) {
      btn.classList.add('cart-empty');
      holder.classList.add('empty');
    } else {
      btn.classList.remove('cart-empty');
      holder.classList.remove('empty');
    }

    wsMain.modules['cart-drawer']._applyPageConfig();
    wsMain.modules['cart-drawer']._renderResumeValues(returnJson, hasProducts);

    holder.style.display = '';
    return true;
  },

  /* Alerta de frete grátis — próprio, não depende mais das globais do app
     nativo "AlertaFreteGratis" (que se abstém quando window.WsApi3Apps.freteGratis).
     Regras (API /cart/shipping/discounts + objeto freeShippingRules do tema) e
     localização do cliente são avaliadas em ApiWS.FreeShipping (wsapi3-wsjs).
     regional = a regra depende de região ainda não confirmada (sem CEP/cidade):
     nunca promete "será grátis" e, atingido o valor, mostra só o aviso, sem barra. */
  async _renderFreteGratisAlert(normalized, bottomMsg) {
    if (!bottomMsg) return;

    let info = null;
    try {
      info = await ApiWS.FreeShipping.evaluate({ total: normalized.total || 0, shipping: normalized.shipping });
    } catch (e) {
      console.error('[CartDrawer] FreeShipping.evaluate:', e);
    }

    let container = document.querySelector('[data-wsjs-frete-gratis]');
    if (!info) {
      if (container) container.remove();
      return;
    }

    if (!container) {
      container = document.createElement('div');
      container.className = 'cd-freteg';
      container.setAttribute('data-wsjs-frete-gratis', '');
      // Primeiro filho de bottomMsg (rodapé fixo) — assim o alerta fica
      // grudado no topo do rodapé, dentro dele, não como irmão solto antes.
      bottomMsg.insertBefore(container, bottomMsg.firstChild);
    }

    const regioes = info.regional ? ' em algumas regi&otilde;es' : '';
    container.innerHTML = info.reached && info.regional
      ? `<div class="cd-freteg-text">Seu pedido pode ter <b>frete gr&aacute;tis</b> para algumas regi&otilde;es. Calcule o frete para confirmar.</div>`
      : info.reached
      ? `<div class="cd-freteg-text"><b>A entrega desse pedido ser&aacute; gr&aacute;tis</b></div>
         <div class="cd-freteg-bar"><div class="cd-freteg-bar-fill" style="width:100%"></div></div>`
      : `<div class="cd-freteg-text">Faltam apenas <b>${wsMain.data.treatPrice(info.missing)}</b> para voc&ecirc; ganhar frete gr&aacute;tis${regioes}</div>
         <div class="cd-freteg-bar"><div class="cd-freteg-bar-fill" style="width:${info.percent}%"></div></div>`;
  },

  _bindEvents(container) {
    if (container.dataset.drawerEvents) return;
    container.dataset.drawerEvents = '1';

    container.addEventListener('click', async (e) => {
      const item = e.target.closest('[data-item-id]');
      if (!item) return;

      const itemId     = item.dataset.itemId;
      const groupId    = item.dataset.groupId || '';
      const qtyInput   = item.querySelector('.cart-qty-input');
      const currentQty = Number(qtyInput?.value || 1);

      if (e.target.closest('.cart-qty-add')) {
        e.preventDefault();
        if (currentQty >= 999) return;
        if (qtyInput) qtyInput.value = currentQty + 1;
        await ApiWS.Calls.cartItemUpdate({ itemId, quantity: currentQty + 1 });
        await wsMain.modules['cart-drawer'].get(true);
        return;
      }

      if (e.target.closest('.cart-qty-sub')) {
        e.preventDefault();
        if (currentQty <= 1) {
          await ApiWS.Calls.cartItemRemove({ itemId, groupId });
        } else {
          if (qtyInput) qtyInput.value = currentQty - 1;
          await ApiWS.Calls.cartItemUpdate({ itemId, quantity: currentQty - 1 });
        }
        await wsMain.modules['cart-drawer'].get(true);
        return;
      }

      if (e.target.closest('.cart-remove-btn')) {
        e.preventDefault();
        await ApiWS.Calls.cartItemRemove({ itemId, groupId });
        await wsMain.modules['cart-drawer'].get(true);
      }
    });

    container.addEventListener('change', async (e) => {
      const item = e.target.closest('[data-item-id]');
      if (!item) return;
      const itemId = item.dataset.itemId;

      if (e.target.matches('.cart-qty-input')) {
        const newQty = Math.max(1, Math.min(999, Number(e.target.value.replace(/\D/g, '') || 1)));
        e.target.value = newQty;
        await ApiWS.Calls.cartItemUpdate({ itemId, quantity: newQty });
        await wsMain.modules['cart-drawer'].get(true);
        return;
      }

      if (e.target.matches('.cart-item-giftwrap-input')) {
        const productId = item.dataset.productId;
        const status = e.target.checked;
        try {
          await ApiWS.Calls.cartItemSetGiftpack({ itemId, productId, status });
          await wsMain.modules['cart-drawer'].get(true);
        } catch (err) {
          console.error('[CartDrawer] giftpack:', err);
          e.target.checked = !status;
        }
      }
    });
  },

  _bindExtras() {
    const holder = document.querySelector('[data-wsjs-cart="holder"]');
    if (!holder || holder.dataset.drawerExtrasBound) return;
    holder.dataset.drawerExtrasBound = '1';

    const bindToggle = (toggleSelector, contentSelector) => {
      const toggleBtn = holder.querySelector(toggleSelector);
      const content    = holder.querySelector(contentSelector);
      if (!toggleBtn || !content) return;

      // Guarda o texto original ("Calcular frete" / "Inserir") pra poder
      // voltar a ele depois de mostrar "Cancelar" com o content aberto.
      const actionEl = toggleBtn.querySelector('.cart-drawer-row__action');
      if (actionEl && !actionEl.dataset.originalText) {
        actionEl.dataset.originalText = actionEl.textContent;
      }

      toggleBtn.addEventListener('click', () => {
        const isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
        toggleBtn.setAttribute('aria-expanded', String(!isOpen));
        // classe em vez de display:none — display não anima, a transição
        // de abrir/fechar (max-height/opacity) está em .cart-drawer-toggle-content
        // no CSS. Limpa um eventual display:none inline deixado por refresh()
        // (estado "cupom/frete selecionado", que esconde o content direto).
        if (!isOpen) content.style.removeProperty('display');
        content.classList.toggle('cd-expanded', !isOpen);
        if (actionEl) actionEl.textContent = isOpen ? actionEl.dataset.originalText : 'Cancelar';
      });
    };

    bindToggle('[data-wsjs-cart="frete-toggle"]', '[data-wsjs-cart="frete-content"]');
    bindToggle('[data-wsjs-cart="cupom-toggle"]', '[data-wsjs-cart="cupom-content"]');

    const freteCep = holder.querySelector('[data-wsjs-cart="frete-cep"]');
    freteCep?.addEventListener('input', (e) => {
      let v = e.target.value.replace(/\D/g, '').slice(0, 8);
      if (v.length > 5) v = v.replace(/(\d{5})(\d)/, '$1-$2');
      e.target.value = v;
    });
    freteCep?.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      wsMain.modules['cart-drawer']._calcularFrete();
    });

    holder.querySelector('[data-wsjs-cart="frete-calcular"]')
      ?.addEventListener('click', () => wsMain.modules['cart-drawer']._calcularFrete());

    holder.querySelector('[data-wsjs-cart="frete-alterar"]')
      ?.addEventListener('click', () => wsMain.modules['cart-drawer']._alterarFrete());

    const cupomInput = holder.querySelector('[data-wsjs-cart="cupom-input"]');
    cupomInput?.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      wsMain.modules['cart-drawer']._aplicarCupom();
    });

    holder.querySelector('[data-wsjs-cart="cupom-aplicar"]')
      ?.addEventListener('click', () => wsMain.modules['cart-drawer']._aplicarCupom());

    holder.querySelector('[data-wsjs-cart="cupom-remover"]')
      ?.addEventListener('click', () => wsMain.modules['cart-drawer']._removerCupom());

    wsMain.modules['cart-drawer']._bindShareIcons(holder);
    wsMain.modules['cart-drawer']._bindCheckoutButton(holder);

    holder.querySelector('[data-wsjs-cart="clean"]')
      ?.addEventListener('click', () => wsMain.modules['cart-drawer']._openCleanDialog());
  },

  /* ─────────────────────────────────────────────
     LIMPAR CARRINHO (sidebarCart.cleanbutton) — mesma confirmação e mesma
     ação do "Limpar carrinho" da página /carrinho (wsapi3-checkout-cart.js /
     openCleanCartConfirm): descarta o cart_token e abre um carrinho novo via
     /cart/start. O popup de lá (#product-popup) só existe naquela página, então
     aqui é um <dialog> próprio com o visual do diálogo de brindes.
  ───────────────────────────────────────────── */
  _openCleanDialog() {
    const mod = wsMain.modules['cart-drawer'];
    if (mod._cleanDialog?.open) return;

    const returnFocus = document.activeElement;
    const dialog = document.createElement('dialog');
    dialog.className = 'cd-gift-dialog cd-clean-dialog';
    dialog.setAttribute('aria-labelledby', 'cd-clean-dialog-title');
    dialog.setAttribute('aria-describedby', 'cd-clean-dialog-description');
    dialog.innerHTML = `
      <button type="button" class="cd-plain-icon-btn cd-gift-dialog-close" aria-label="Fechar" data-clean-cancel><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>
      <h2 id="cd-clean-dialog-title">Limpar Carrinho</h2>
      <p id="cd-clean-dialog-description">Voc&ecirc; deseja limpar o carrinho?</p>
      <div class="cd-clean-dialog-btns">
        <button type="button" class="button-main" data-clean-confirm>Sim</button>
        <button type="button" class="cart-drawer-link-btn" data-clean-cancel>Cancelar</button>
      </div>`;
    document.body.append(dialog);
    mod._cleanDialog = dialog;

    const close = () => {
      dialog.close();
      dialog.remove();
      mod._cleanDialog = null;
      if (returnFocus?.isConnected) returnFocus.focus();
    };

    dialog.addEventListener('cancel', e => { e.preventDefault(); close(); });
    dialog.addEventListener('click', e => {
      if (e.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
    });
    dialog.querySelectorAll('[data-clean-cancel]').forEach(b => b.addEventListener('click', close));

    const confirmBtn = dialog.querySelector('[data-clean-confirm]');
    confirmBtn.addEventListener('click', async () => {
      if (confirmBtn.disabled) return;
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Limpando...';
      try {
        localStorage.removeItem('orderIdKeepTC_B');
        try { localStorage.removeItem(mod._cartSnapshotKey()); } catch (_) {}
        await ApiWS.Calls.cartStart();
      } catch (err) {
        console.error('[CartDrawer] cleanCart:', err);
      }
      close();
      // Na própria /carrinho a página inteira mostra o carrinho — recarrega,
      // igual o botão de lá. Nas demais, basta re-renderizar o drawer.
      if (/^\/carrinho\/?$/i.test(window.location.pathname)) {
        window.location.reload();
        return;
      }
      mod._lastSelectedFrete = null;
      await mod.get(true);
    });

    dialog.showModal();
    confirmBtn.focus();
  },

  /* ─────────────────────────────────────────────
     "IR PARA O PAGAMENTO" — mesmo fluxo do botão "Finalizar compra" do
     carrinho completo (wsapi3-checkout-cart.js): fecha o pedido via
     /cart/close ANTES de navegar, porque é essa chamada que gera o
     checkout_token (ct2)/order_number que o /checkout espera na URL — não
     dá pra só linkar direto pra lá. shippingOnCheckout:true manda
     shipping_on_checkout=1 pro /cart/close, permitindo fechar sem frete
     calculado ainda (o drawer não obriga isso, diferente do carrinho
     completo, que bloqueia o botão se o frete não foi calculado).
  ───────────────────────────────────────────── */
  _bindCheckoutButton(holder) {
    const mod = wsMain.modules['cart-drawer'];
    const alert = holder.querySelector('[data-wsjs-cart="gift-alert"]');
    if (alert && !alert.dataset.bound) {
      alert.dataset.bound = '1';
      alert.addEventListener('click', () => mod._openGiftDialog('choose'));
    }
    const btn = holder.querySelector('[data-wsjs-cart-action="checkout"]');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';

    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (btn.dataset.loading || mod._giftAdding) return;
      // O preview não contém brindes: consulta o carrinho completo se esse
      // for o único estado disponível, sem decidir com dados antigos.
      if (!mod._giftCart && !mod._cfgHidden('brindes')) {
        btn.dataset.loading = '1';
        try {
          mod._syncGiftPrompt(await mod._fetchFullDetails());
        } catch (err) {
          wsMain.showAlert('Não foi possível atualizar o carrinho. Tente novamente.', 'Atenção');
          return;
        } finally {
          btn.dataset.loading = '';
        }
      }
      if (mod._needsGiftChoice()) {
        mod._openGiftDialog('reminder');
        return;
      }
      await mod._continueCheckout(btn);
    });
  },

  async _continueCheckout(btn) {
      if (!btn || btn.dataset.loading || this._giftAdding) return;
      // Multi CD: item sem estoque em nenhum CD ou pacote sem forma de envio
      // não deixam avançar (a escolha em si pode ficar pro checkout).
      const multiCdBlock = this._multiCd ? ApiWS.MultiCd.blockReason(this._multiCd.parsed) : '';
      if (multiCdBlock) {
        wsMain.showAlert(multiCdBlock, 'Atenção');
        this._alterarFrete();
        return;
      }
      btn.dataset.loading = '1';
      const originalLabel = btn.textContent;
      btn.textContent = 'Processando...';

      try {
        const result = await ApiWS.Calls.cartClose({ shippingOnCheckout: true });
        if (result?.result === 'success' && result?.record) {
          const { cart_token, checkout_token, order_number } = result.record;
          const params = new URLSearchParams({ ct: cart_token, ct2: checkout_token, order_number });
          window.location.href = `/checkout?${params.toString()}`;
          return;
        }
        wsMain.showAlert(result?.message || 'Não foi possível finalizar o pedido.', 'Atenção');
        // Estoque/alocação por CD mudou ou falta frete de algum pacote: volta pro frete.
        if (ApiWS.MultiCd.needsRecalc(result)) this._reopenFrete(result.message);
      } catch (err) {
        console.error('[CartDrawer] cartClose:', err);
        wsMain.showAlert('Erro ao finalizar o pedido. Tente novamente.', 'Atenção');
      }
      btn.dataset.loading = '';
      btn.textContent = originalLabel;
  },

  _giftState(cart) {
    const gifts = Array.isArray(cart?.gifts) ? cart.gifts : [];
    const products = cart?.products || [];
    // storeGift é o sinal explícito; SKU mantém compatibilidade com o
    // contrato usado pela lista de brindes existente.
    const chosen = products.find(p => Number(p.qtd) > 0 && (p.isGift || gifts.some(g =>
      g.gift_product?.sku && p.sku && String(g.gift_product.sku).trim() === String(p.sku).trim())));
    return {
      chosen,
      available: products.length ? gifts.filter(g => g.applicable && g.gift_product?.id) : [],
    };
  },

  _needsGiftChoice() {
    const state = this._giftState(this._giftCart);
    return !this._cfgHidden('brindes') && !state.chosen && state.available.length > 0;
  },

  _syncGiftPrompt(cart) {
    this._giftCart = cart.isFull ? cart : null;
    const alert = document.querySelector('[data-wsjs-cart="gift-alert"]');
    if (alert) alert.style.display = this._needsGiftChoice() ? '' : 'none';
    if (this._giftDialog?.open) {
      if (!this._needsGiftChoice()) this._closeGiftDialog();
      else if (!this._giftAdding) this._openGiftDialog(this._giftDialog.dataset.mode);
    }
  },

  _closeGiftDialog() {
    this._giftSlider?.destroy();
    this._giftSlider = null;
    this._giftDialog?.close();
    this._giftDialog?.remove();
    this._giftDialog = null;
    const target = this._giftReturnFocus;
    this._giftReturnFocus = null;
    if (target?.isConnected) target.focus();
  },

  _openGiftDialog(mode) {
    if (!this._needsGiftChoice()) return;
    const mod = this;
    let dialog = mod._giftDialog;
    if (!dialog) {
      mod._giftReturnFocus = document.activeElement;
      dialog = document.createElement('dialog');
      dialog.className = 'cd-gift-dialog';
      dialog.setAttribute('aria-labelledby', 'cd-gift-dialog-title');
      dialog.setAttribute('aria-describedby', 'cd-gift-dialog-description');
      document.body.append(dialog);
      mod._giftDialog = dialog;
      dialog.addEventListener('cancel', e => { e.preventDefault(); mod._closeGiftDialog(); });
      dialog.addEventListener('click', e => {
        if (e.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) mod._closeGiftDialog();
        }
      });
    }
    mod._giftSlider?.destroy();
    mod._giftSlider = null;
    dialog.dataset.mode = mode;
    const choosing = mode === 'choose';
    const icon = document.querySelector('[data-wsjs-cart="gift-alert"] svg')?.outerHTML || '';
    dialog.innerHTML = `
      <button type="button" class="cd-plain-icon-btn cd-gift-dialog-close" aria-label="Fechar" data-gift-close><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>
      <div class="cd-gift-dialog-icon">${icon}</div>
      <h2 id="cd-gift-dialog-title">${choosing ? 'Escolha seu brinde' : 'Seu brinde está esperando!'}</h2>
      <p id="cd-gift-dialog-description">${choosing ? 'Selecione um dos brindes disponíveis para sua compra.' : 'Você tem direito a um brinde nesta compra. Escolha o seu antes de continuar.'}</p>
      ${choosing ? '<div class="cd-gift-slider"></div><p class="cd-gift-error" role="alert"></p>' : '<button type="button" class="button-main" data-gift-choose>Escolher meu brinde</button>'}
      <button type="button" class="cart-drawer-link-btn cd-gift-later" data-gift-later>${choosing ? 'Escolher depois' : 'Continuar sem brinde'}</button>`;
    dialog.querySelector('[data-gift-close]').onclick = () => mod._closeGiftDialog();
    dialog.querySelector('[data-gift-later]').onclick = () => {
      mod._closeGiftDialog();
      if (!choosing) mod._continueCheckout(document.querySelector('[data-wsjs-cart-action="checkout"]'));
    };
    if (!choosing) dialog.querySelector('[data-gift-choose]').onclick = () => mod._openGiftDialog('choose');
    if (choosing) {
      const container = dialog.querySelector('.cd-gift-slider');
      const gifts = mod._giftState(mod._giftCart).available;
      gifts.forEach(gift => {
        const gp = gift.gift_product;
        const card = document.createElement('div');
        card.className = 'cd-gift-card';
        card.innerHTML = '<div class="cd-gift-card-photo"></div><p class="cd-gift-card-name"></p><span class="cd-gift-status cd-gift-status--ok">Grátis</span><button type="button" class="button-main" data-keen-slider-clickable>Escolher esse brinde</button>';
        card.querySelector('.cd-gift-card-name').textContent = gp.name || 'Brinde';
        if (gp.photo) {
          const img = document.createElement('img');
          img.src = gp.photo;
          img.alt = gp.name || 'Brinde';
          card.querySelector('.cd-gift-card-photo').append(img);
        }
        const button = card.querySelector('button');
        button.onclick = () => mod._chooseGift(button, gp.id);
        container.append(card);
      });
      if (!dialog.open) dialog.showModal();
      if (typeof KeenSlider !== 'undefined') {
        const perView = Math.min(gifts.length, window.innerWidth < 540 ? 1 : window.innerWidth < 800 ? 2 : 3);
        const arrow = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m9 5 7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        const [, slider] = wsMain.tools.createSlide(container, { slides: { perView, spacing: 16 }, loop: false, prevArrow: arrow, nextArrow: arrow, arrowsType: 'group', dots: true, dotsType: 'group' });
        mod._giftSlider = slider || null;
        container.querySelectorAll('.arrow, .slide-dots').forEach(control => {
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          const index = Array.from(container.querySelectorAll('.slide-dots')).indexOf(control) + 1;
          control.setAttribute('aria-label', control.classList.contains('arrow--prev') ? 'Brinde anterior' : control.classList.contains('arrow--next') ? 'Próximo brinde' : `Página de brindes ${index}`);
          control.onkeydown = e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); control.click(); } };
        });
      }
    } else if (!dialog.open) dialog.showModal();
    dialog.querySelector(choosing ? '.cd-gift-card button' : '[data-gift-choose]')?.focus();
  },

  async _chooseGift(btn, productId, removeItemId = null) {
    if (this._giftAdding) return;
    this._giftAdding = true;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adicionando...';
    const error = this._giftDialog?.querySelector('.cd-gift-error');
    if (error) error.textContent = '';
    try {
      if (removeItemId) {
        const removed = await ApiWS.Calls.cartItemRemove({ itemId: removeItemId });
        if (removed?.result !== 'success') throw new Error(removed?.message || 'Não foi possível trocar o brinde.');
      }
      const result = await ApiWS.Calls.cartAddItem({ productId, quantity: 1, isGift: true });
      if (result?.result !== 'success') throw new Error(result?.message || 'Não foi possível adicionar o brinde.');
      await this.get(true);
      this._closeGiftDialog();
    } catch (err) {
      if (error?.isConnected) error.textContent = err.message || 'Não foi possível adicionar o brinde. Tente novamente.';
      else wsMain.showAlert(err.message || 'Não foi possível adicionar o brinde. Tente novamente.', 'Atenção');
    } finally {
      this._giftAdding = false;
      btn.disabled = false;
      btn.textContent = label;
    }
  },

  /* ─────────────────────────────────────────────
     COMPARTILHAR (WhatsApp / copiar link) — mesmo link e chave de
     ofuscação do botão "Compartilhar" do carrinho (wsapi3-checkout-cart.js
     / createSharePopup), só que direto nos ícones do cabeçalho, sem popup.
  ───────────────────────────────────────────── */
  _buildShareLink() {
    const token  = (localStorage['orderIdKeepTC_B'] || '').trim();
    const obfKey = wsMain.modules['cart-drawer']._shareObfKey;
    const shareParam = token ? `${obfKey}${token}${obfKey}` : '';
    return `${window.location.protocol}//${window.location.host}/carrinho?share_cart=${shareParam}`;
  },

  _fallbackCopy(text, done) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
    if (done) done();
  },

  _bindShareIcons(holder) {
    const toggleBtn = holder.querySelector('[data-wsjs-cart="share-toggle"]');
    const dropdown  = holder.querySelector('[data-wsjs-cart="share-dropdown"]');
    const waBtn     = holder.querySelector('[data-wsjs-cart="share-whatsapp"]');
    const copyBtn   = holder.querySelector('[data-wsjs-cart="share-copy"]');
    const waIcon    = holder.querySelector('[data-wsjs-cart="share-whatsapp-icon"]');
    const copyIcon  = holder.querySelector('[data-wsjs-cart="share-copy-icon"]');
    const copyLabel = holder.querySelector('[data-wsjs-cart="share-copy-label"]');

    // Ícone próprio, sem depender de wsMain.globalData.icons.whatsapp — esse
    // vinha sem width/height compatível e estourava o botão.
    const whatsappSvg = `<svg viewBox="0 0 32 32"><path fill="#25D366" d="M16 3C9 3 3 9 3 16c0 2.3.6 4.5 1.8 6.4L3 29l6.8-1.8A13 13 0 0 0 16 29c7 0 13-6 13-13S23 3 16 3zm6.3 18.3c-.3.8-1.5 1.5-2 1.6-.6.1-1.1.1-1.6 0-.5-.1-1.1-.3-1.9-.7-3.3-1.4-5.4-4.8-5.6-5-.2-.2-1.3-1.7-1.3-3.3 0-1.6.8-2.4 1.1-2.7.3-.3.6-.4.9-.4h.6c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .6l-.5.6-.3.4c.2.3.8 1.3 1.7 2.1 1.1 1 2.1 1.4 2.4 1.5.3.1.5 0 .6-.1l.8-.9c.2-.2.4-.2.6-.1l2 .9c.2.1.4.2.4.4v.8z"/></svg>`;
    const linkSvg  = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 12h6M8 17H6a5 5 0 0 1 0-10h2M16 7h2a5 5 0 0 1 0 10h-2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`;
    const checkSvg = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    if (waIcon) waIcon.innerHTML = whatsappSvg;
    if (copyIcon) copyIcon.innerHTML = linkSvg;

    const closeDropdown = () => {
      dropdown?.classList.remove('cd-open');
      toggleBtn?.setAttribute('aria-expanded', 'false');
    };

    if (toggleBtn && dropdown && !toggleBtn.dataset.bound) {
      toggleBtn.dataset.bound = '1';

      toggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = dropdown.classList.toggle('cd-open');
        toggleBtn.setAttribute('aria-expanded', String(isOpen));
      });

      // fecha ao clicar fora ou apertar Escape
      document.addEventListener('click', (e) => {
        if (!dropdown.classList.contains('cd-open')) return;
        if (e.target === toggleBtn || toggleBtn.contains(e.target) || dropdown.contains(e.target)) return;
        closeDropdown();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDropdown();
      });
    }

    if (waBtn && !waBtn.dataset.bound) {
      waBtn.dataset.bound = '1';
      waBtn.addEventListener('click', () => {
        const link = wsMain.modules['cart-drawer']._buildShareLink();
        const text = encodeURIComponent(`Veja o carrinho que montei para você. ${link}`);
        window.open(`https://wa.me/?text=${text}`, '_blank');
        closeDropdown();
      });
    }

    if (copyBtn && !copyBtn.dataset.bound) {
      copyBtn.dataset.bound = '1';
      copyBtn.addEventListener('click', () => {
        const link = wsMain.modules['cart-drawer']._buildShareLink();
        const done = () => {
          if (copyIcon) copyIcon.innerHTML = checkSvg;
          if (copyLabel) copyLabel.textContent = 'Link copiado!';
          setTimeout(() => {
            if (copyIcon) copyIcon.innerHTML = linkSvg;
            if (copyLabel) copyLabel.textContent = 'Copiar link';
            closeDropdown();
          }, 1200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(link).then(done)
            .catch(() => wsMain.modules['cart-drawer']._fallbackCopy(link, done));
        } else {
          wsMain.modules['cart-drawer']._fallbackCopy(link, done);
        }
      });
    }
  },

  /* ─────────────────────────────────────────────
     BRINDES — versão própria do módulo. O gift-slider de
     wsapi3-checkout-cart.js só carrega na página /carrinho (etapa:"CARRINHO"
     no config.json), então nunca rodava quando o drawer abre em qualquer
     outra página — os brindes simplesmente nunca apareciam ali. Usa
     `returnJson.gifts`, já vindo cru do /cart/view (mesmo campo que o
     gift-slider consome via window.cartJson.gifts).
  ───────────────────────────────────────────── */
  _renderGifts(returnJson) {
    const holder  = document.querySelector('[data-wsjs-cart="holder"]');
    const section = holder?.querySelector('[data-wsjs-cart="gifts"]');
    const list    = holder?.querySelector('[data-wsjs-cart="gifts-list"]');
    if (!section || !list) return;

    if (wsMain.modules['cart-drawer']._cfgHidden('brindes')) { section.classList.add('cd-cfg-hidden'); list.innerHTML = ''; return; }

    const gifts = Array.isArray(returnJson.gifts) ? returnJson.gifts : [];
    if (!gifts.length) {
      section.style.display = 'none';
      list.innerHTML = '';
      wsMain.modules['cart-drawer']._updateGiftsPeek();
      return;
    }

    const cartSkus = (returnJson.products || []).filter(p => p.sku).map(p => p.sku);
    const chosenProduct = wsMain.modules['cart-drawer']._giftState(returnJson).chosen;
    const chosenItemId = chosenProduct?.item_id || null;

    list.innerHTML = gifts.map(gift => {
      const gp = gift.gift_product;
      if (!gp) return '';

      const giftSku  = gp.sku ? String(gp.sku).trim() : '';
      const isChosen = !!((giftSku && cartSkus.includes(giftSku)) || (chosenProduct?.isGift && String(chosenProduct.product_id) === String(gp.id)));
      const applicable = !!gift.applicable;
      const img = gp.photo
        ? `<img src="${gp.photo}" alt="${(gp.name || '').replace(/"/g, '&quot;')}">`
        : '';

      let statusHtml;
      if (isChosen) {
        statusHtml = `<span class="cd-gift-status cd-gift-status--chosen">Escolhido</span>`;
      } else if (applicable) {
        statusHtml = `<span class="cd-gift-status cd-gift-status--ok">Dispon&iacute;vel</span>`;
      } else {
        const missing = Number(gift.min_value_applied || 0) - Number(returnJson.total || 0);
        statusHtml = `<span class="cd-gift-status cd-gift-status--wait">Ainda n&atilde;o liberado</span>`
          + (missing > 0 ? `<span class="cd-gift-missing">Faltam ${wsMain.data.treatPrice(missing)}</span>` : '');
      }

      const actionHtml = (!isChosen && applicable)
        ? `<button type="button" class="cart-drawer-link-btn" data-action="choose-gift" data-product-id="${gp.id}" ${chosenItemId ? `data-remove-item-id="${chosenItemId}"` : ''}>Quero esse brinde</button>`
        : '';

      return `
        <div class="cd-suggestion-item">
          <span class="cd-suggestion-item__img">${img}</span>
          <div class="cd-suggestion-item__info">
            <span class="cd-suggestion-item__name">${gp.name || 'Brinde'}</span>
            <div class="cd-gift-meta">${statusHtml}</div>
            ${actionHtml}
          </div>
        </div>`;
    }).join('');

    section.style.display = '';
    wsMain.modules['cart-drawer']._updateGiftsPeek();

    if (!list.dataset.bound) {
      list.dataset.bound = '1';
      list.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-action="choose-gift"]');
        if (!btn) return;
        e.preventDefault();
        const productId   = btn.dataset.productId;
        const removeItemId = btn.dataset.removeItemId || null;
        if (!productId) return;

        await wsMain.modules['cart-drawer']._chooseGift(btn, productId, removeItemId);
      });
    }
  },

  /* ─────────────────────────────────────────────
     SUGESTÕES PRA VOCÊ — usa ApiWS.Calls.listProducts.suggestion() (já existia em
     wsapi3-wsjs.js, mas nunca tinha sido conectado a nenhuma UI). Depende
     de window.cartJson, publicado em _fetchFullDetails() acima.
  ───────────────────────────────────────────── */
  // Sugestão/recomendado com variação (ou KIT) não entra direto no carrinho:
  // /cart/items/add responde result "error_redirect" (PRODUCT_REQUIRES_SELECTION)
  // + url_redirect. Antes o botão só ficava em "Adicionando..." sem fazer nada —
  // agora leva o cliente pra página do produto escolher a variação (mesma regra
  // de _wsFuncComprarSimples, em wsapi3-adaptions-api2-to-api3). true = redirecionou.
  _redirectIfNeedsSelection(result, itemEl) {
    if (result?.result !== 'error_redirect' && result?.error_code !== 'PRODUCT_REQUIRES_SELECTION') return false;
    const url = result?.url_redirect || itemEl?.querySelector('a[href]:not([href="#"])')?.getAttribute('href');
    if (!url) return false;
    window.location.href = url;
    return true;
  },

  async _renderSuggestions() {
    const holder  = document.querySelector('[data-wsjs-cart="holder"]');
    const section = holder?.querySelector('[data-wsjs-cart="suggestions"]');
    const list    = holder?.querySelector('[data-wsjs-cart="suggestions-list"]');
    if (!section || !list) return;

    if (wsMain.modules['cart-drawer']._cfgHidden('sugeridos')) { section.classList.add('cd-cfg-hidden'); list.innerHTML = ''; return; }

    let products = [];
    try {
      products = await ApiWS.Calls.listProducts.suggestion();
    } catch (e) {
      console.error('[CartDrawer] suggestion:', e);
    }

    if (!Array.isArray(products) || !products.length) {
      section.style.display = 'none';
      list.innerHTML = '';
      wsMain.modules['cart-drawer']._updateSuggestionsPeek();
      return;
    }

    list.innerHTML = products.slice(0, 6).map(p => {
      const foto       = Array.isArray(p.fotos) ? (typeof p.fotos[0] === 'string' ? p.fotos[0] : p.fotos[0]?.normal || '') : '';
      const url        = p.links?.ver_produto || '#';

      return `
        <div class="cd-suggestion-item" data-product-id="${p.id}">
          <a href="${url}" class="cd-suggestion-item__img"><img src="${foto}" alt="${p.nome || ''}" loading="lazy"></a>
          <div class="cd-suggestion-item__info">
            <a href="${url}" class="cd-suggestion-item__name">${p.nome || ''}</a>
            <div class="cd-suggestion-item__prices cd-price-block">${wsMain.modules['cart-drawer']._suggestionPriceHtml(p)}</div>
            <button type="button" class="cart-drawer-link-btn" data-action="add-suggestion">Adicionar ao carrinho</button>
          </div>
        </div>`;
    }).join('');

    section.style.display = '';
    wsMain.modules['cart-drawer']._updateSuggestionsPeek();

    if (!list.dataset.bound) {
      list.dataset.bound = '1';
      list.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-action="add-suggestion"]');
        if (!btn) return;
        e.preventDefault();
        const item = btn.closest('[data-product-id]');
        const productId = item?.dataset.productId;
        if (!productId) return;

        btn.disabled = true;
        const originalLabel = btn.textContent;
        btn.textContent = 'Adicionando...';
        try {
          const result = await ApiWS.Calls.cartAddItem({ productId, quantity: 1 });
          if (wsMain.modules['cart-drawer']._redirectIfNeedsSelection(result, item)) return;
          await wsMain.modules['cart-drawer'].get(true);
        } catch (err) {
          console.error('[CartDrawer] addSuggestion:', err);
          btn.disabled = false;
          btn.textContent = originalLabel;
        }
      });
    }
  },

  // Mostra só os 2 primeiros itens + metade do 3º (com degradê por cima),
  // com uma seta embaixo pra expandir a lista inteira. Altura calculada via
  // DOM (offsetTop/offsetHeight) em vez de um valor fixo em rem, porque a
  // altura de cada item varia (nome de 1 ou 2 linhas). Genérico — usado por
  // sugestões e brindes, cada um com seus próprios data-wsjs-cart.
  _updateSuggestionsPeek() {
    wsMain.modules['cart-drawer']._updatePeekList('suggestions-list-wrap', 'suggestions-list', 'suggestions-more', 'suggestions-fade');
  },

  _updateGiftsPeek() {
    wsMain.modules['cart-drawer']._updatePeekList('gifts-list-wrap', 'gifts-list', 'gifts-more', 'gifts-fade');
  },

  _updatePeekList(wrapAttr, listAttr, moreAttr, fadeAttr) {
    const wrap    = document.querySelector(`[data-wsjs-cart="${wrapAttr}"]`);
    const list    = document.querySelector(`[data-wsjs-cart="${listAttr}"]`);
    const moreBtn = document.querySelector(`[data-wsjs-cart="${moreAttr}"]`);
    const fade    = document.querySelector(`[data-wsjs-cart="${fadeAttr}"]`);
    if (!wrap || !list || !moreBtn) return;

    const items = Array.from(list.children);

    if (items.length <= 2) {
      wrap.style.maxHeight = 'none';
      wrap.classList.remove('cd-expanded');
      moreBtn.style.display = 'none';
      moreBtn.classList.remove('cd-expanded');
      if (fade) fade.style.display = 'none';
      return;
    }

    const third = items[2];
    const collapsedHeight = Math.round(third.offsetTop + third.offsetHeight / 2);
    wrap.dataset.collapsedHeight = String(collapsedHeight);
    wrap.style.maxHeight = collapsedHeight + 'px';
    wrap.classList.remove('cd-expanded');
    moreBtn.style.display = '';
    moreBtn.classList.remove('cd-expanded');
    if (fade) fade.style.display = '';

    if (!moreBtn.dataset.bound) {
      moreBtn.dataset.bound = '1';
      moreBtn.addEventListener('click', () => {
        const expanded = !wrap.classList.contains('cd-expanded');
        wrap.classList.toggle('cd-expanded', expanded);
        moreBtn.classList.toggle('cd-expanded', expanded);
        wrap.style.maxHeight = expanded ? list.scrollHeight + 'px' : `${wrap.dataset.collapsedHeight}px`;
        if (fade) fade.style.display = expanded ? 'none' : '';
      });
    }
  },

  _deadlineLabel(opt) {
    if (opt.deadline_display) return opt.deadline_display;
    if (opt.deadline > 1) return `${opt.deadline} dias úteis`;
    if (opt.deadline === 1) return `${opt.deadline} dia útil`;
    if (opt.deadline === 0) return 'Hoje';
    return '';
  },

  // Mesma chave usada em wsapi3-checkout-cart.js (CEP_CART_KEEP) — assim o
  // CEP calculado numa tela pré-preenche a outra. Chamado a cada refresh()
  // (não só na primeira abertura do drawer), pra pegar um CEP salvo depois
  // que o drawer já tinha sido montado (ex: usuário calculou na página
  // /carrinho e depois abriu o drawer lateral na mesma sessão).
  _prefillCep() {
    const input = document.querySelector('[data-wsjs-cart="frete-cep"]');
    if (!input || input.value) return;
    try {
      const savedCep = localStorage.getItem('CEP_CART_KEEP');
      if (savedCep) {
        input.value = savedCep.length === 8 ? savedCep.slice(0, 5) + '-' + savedCep.slice(5) : savedCep;
      }
    } catch (e) {}
  },

  async _calcularFrete() {
    const holder  = document.querySelector('[data-wsjs-cart="holder"]');
    const input   = holder.querySelector('[data-wsjs-cart="frete-cep"]');
    const btn     = holder.querySelector('[data-wsjs-cart="frete-calcular"]');
    const msg     = holder.querySelector('[data-wsjs-cart="frete-msg"]');
    const options = holder.querySelector('[data-wsjs-cart="frete-options"]');

    const clean = String(input?.value || '').replace(/\D/g, '');
    msg.style.display = 'none';
    options.innerHTML = '';

    if (clean.length !== 8) {
      msg.textContent = 'Digite um CEP válido.';
      msg.style.display = '';
      return;
    }

    btn.disabled = true;
    const originalLabel = btn.textContent;
    btn.textContent = 'Calculando...';

    try {
      const result = await ApiWS.Calls.cartShippingCalculate(clean);
      const multiCd = result?.result === 'success' ? ApiWS.MultiCd.parse(result) : null;
      wsMain.modules['cart-drawer']._multiCd = null;

      if (multiCd) {
        try { localStorage.setItem('CEP_CART_KEEP', clean); } catch (e) {}
        await wsMain.modules['cart-drawer']._renderMultiCd(multiCd, clean);
        ApiWS.LegacyHooks.shippingCalculated({ zipcode: clean, options: multiCd.groups.flatMap(g => g.options) });
      } else if (result?.result === 'success' && result?.records?.length) {
        try { localStorage.setItem('CEP_CART_KEEP', clean); } catch (e) {}
        result.records.forEach((opt) => {
          const priceLabel = opt.is_free ? 'Grátis' : (opt.price_display || wsMain.data.treatPrice(opt.price));
          const deadline = wsMain.modules['cart-drawer']._deadlineLabel(opt);

          // A API manda opt.selected:true pra opção recomendada (normalmente
          // a mais barata), mas isso não é uma escolha do cliente — ele
          // precisa clicar numa opção pra de fato selecioná-la. Marcar como
          // "selected" antes disso (borda azul + fundo cinza) sugeria que já
          // tinha um frete escolhido sem nenhuma ação do cliente.
          const row = document.createElement('div');
          row.className = 'cart-drawer-frete-option';
          row.innerHTML = `
            <span>${opt.name || ''}${deadline ? ' &middot; ' + deadline : ''}</span>
            <span class="cart-drawer-frete-option-price">${priceLabel}</span>
          `;
          row.addEventListener('click', () => wsMain.modules['cart-drawer']._selecionarFrete(opt, clean));
          options.appendChild(row);
        });
        ApiWS.LegacyHooks.shippingCalculated({ zipcode: clean, options: result.records });
      } else {
        msg.textContent = 'Frete indisponível para esta região.';
        msg.style.display = '';
      }
    } catch (e) {
      console.error('[CartDrawer] calcularFrete:', e);
      msg.textContent = 'Não foi possível calcular o frete.';
      msg.style.display = '';
    } finally {
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  },

  async _selecionarFrete(opt, zipcode) {
    const msg = document.querySelector('[data-wsjs-cart="frete-msg"]');
    const options = document.querySelector('[data-wsjs-cart="frete-options"]');
    // Mesmo spinner usado na abertura do carrinho (.cd-loading-spinner) — só
    // que aqui substitui a lista de opções em vez de cobrir o drawer inteiro,
    // pra não parecer que travou enquanto /cart/shipping/select responde.
    // Guarda o HTML da lista pra poder devolver se a chamada falhar (sem
    // isso, um erro deixava a área vazia, sem opções pra tentar de novo).
    const previousOptionsHtml = options ? options.innerHTML : '';
    if (options) {
      options.innerHTML = '<div class="cart-drawer-frete-loading"><div class="cd-loading-spinner"></div></div>';
    }
    try {
      await ApiWS.Calls.cartShippingSelect({
        shippingId: opt.id,
        shippingName: opt.name,
        shippingPrice: opt.price,
        shippingDiscount: opt.discount || 0,
        shippingDeadline: opt.deadline,
        zipcode,
      });
      // O /cart/view nem sempre devolve nome/valor do frete recém-selecionado
      // (campo "shipping" vem incompleto), então guardamos os dados aqui mesmo,
      // que já temos completos, para exibir a linha "Frete: ..." imediatamente.
      wsMain.modules['cart-drawer']._lastSelectedFrete = {
        name: opt.name,
        deadline: wsMain.modules['cart-drawer']._deadlineLabel(opt),
        priceLabel: opt.is_free ? 'Grátis' : (opt.price_display || wsMain.data.treatPrice(opt.price)),
      };
      wsMain.modules['cart-drawer']._freteEditing = false;
      await wsMain.modules['cart-drawer'].get(true);
      ApiWS.Analytics?.addShippingInfo(window.cartJson?.products, window.cartJson?.subtotal, opt.name);
      ApiWS.LegacyHooks.shippingSelected({ zipcode, option: opt });
    } catch (e) {
      console.error('[CartDrawer] selecionarFrete:', e);
      if (options) options.innerHTML = previousOptionsHtml;
      if (msg) {
        msg.textContent = 'Não foi possível selecionar este frete.';
        msg.style.display = '';
      }
    }
  },

  /* ─────────────────────────────────────────────
     MULTI CD — carrinho com produto alocado em vários centros de
     distribuição: um bloco por pacote (ApiWS.MultiCd, wsapi3-wsjs), cada um
     com as próprias opções e um /cart/shipping/select por cd_id. Carrinho
     comum nunca passa por aqui (_multiCd fica null).
  ───────────────────────────────────────────── */
  _multiCd: null,
  _multiCdRecalcAt: 0,

  _drawMultiCd() {
    const mod = wsMain.modules['cart-drawer'];
    const session = mod._multiCd;
    const options = document.querySelector('[data-wsjs-cart="frete-options"]');
    if (!session || !options) return;
    options.innerHTML = '';
    ApiWS.MultiCd.render(options, session.parsed, {
      products: window.cartJson?.products,
      session,
      renderOption: (opt) => {
        const priceLabel = opt.is_free ? 'Grátis' : (opt.price_display || wsMain.data.treatPrice(opt.price));
        const deadline = mod._deadlineLabel(opt);
        const row = document.createElement('div');
        row.className = 'cart-drawer-frete-option';
        row.innerHTML = `
            <span>${ApiWS.MultiCd._esc(opt.name || '')}${deadline ? ' &middot; ' + deadline : ''}</span>
            <span class="cart-drawer-frete-option-price">${priceLabel}</span>
          `;
        return row;
      },
      setSelected: (row, on) => row.classList.toggle('selected', on),
      onSelect: (group, opt) => mod._selecionarFreteMultiCd(group, opt),
    });
  },

  // Depois de escolher o frete de um envio, leva a lista até o próximo
  // envio ainda sem escolha (o seguinte; se já escolhido, o primeiro pendente).
  _scrollToNextMultiCd(group) {
    const session = wsMain.modules['cart-drawer']._multiCd;
    if (!session) return;
    const groups = session.parsed.groups;
    const from = groups.findIndex(g => g.cdId === group.cdId);
    const next = groups.slice(from + 1).concat(groups.slice(0, from + 1)).find(g => !session.choices[g.cdId]);
    if (!next) return;
    requestAnimationFrame(() => {
      const box = Array.from(document.querySelectorAll('[data-wsjs-cart="frete-options"] .ws-multicd-group'))
        .find(b => b.getAttribute('data-cd-id') === String(next.cdId));
      box?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  },

  _multiCdMsg(text) {
    const msg = document.querySelector('[data-wsjs-cart="frete-msg"]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.style.display = text ? '' : 'none';
  },

  // Com 2+ pacotes nada vem marcado: o cliente escolhe envio por envio (ao
  // escolher um, a lista rola pro próximo). Com 1 pacote, a pré-seleção da
  // API (selected:true) é gravada na hora, como no carrinho comum. Os blocos
  // ficam abertos (_freteEditing) até todos os pacotes terem frete.
  async _renderMultiCd(parsed, zipcode) {
    const mod = wsMain.modules['cart-drawer'];
    const session = ApiWS.MultiCd.session(parsed, { zipcode });
    mod._multiCd = session;
    mod._lastSelectedFrete = null;
    mod._freteEditing = true;
    ApiWS.MultiCd.remember(parsed, localStorage['orderIdKeepTC_B']);
    mod._drawMultiCd();

    const block = ApiWS.MultiCd.blockReason(parsed);
    if (block) { mod._multiCdMsg(block); return; }
    if (parsed.groups.length > 1) return;

    try {
      const r = await session.selectPreselected();
      if (r?.result !== 'success') { mod._multiCdError(r); return; }
    } catch (e) {
      console.error('[CartDrawer] multiCd preselect:', e);
    }
    mod._drawMultiCd();
    await mod.get(true);
  },

  async _selecionarFreteMultiCd(group, opt) {
    const mod = wsMain.modules['cart-drawer'];
    const session = mod._multiCd;
    if (!session) return;
    mod._multiCdMsg('');
    try {
      const r = await session.select(group, opt);
      if (r?.result !== 'success') { mod._multiCdError(r); return; }
      ApiWS.LegacyHooks.shippingSelected({ zipcode: session.zipcode, option: opt });
      if (session.isComplete()) {
        const sum = session.summary();
        mod._lastSelectedFrete = {
          name: sum.name,
          deadline: mod._deadlineLabel({ deadline: sum.deadline }),
          priceLabel: (sum.free || sum.price === 0) ? 'Grátis' : wsMain.data.treatPrice(sum.price),
        };
        mod._freteEditing = false;
        ApiWS.Analytics?.addShippingInfo(window.cartJson?.products, window.cartJson?.subtotal, sum.name);
      } else {
        mod._multiCdMsg('Escolha a forma de envio dos demais pacotes.');
      }
      await mod.get(true);
      if (!session.isComplete()) mod._scrollToNextMultiCd(group);
    } catch (e) {
      console.error('[CartDrawer] selecionarFreteMultiCd:', e);
      mod._drawMultiCd();
      mod._multiCdMsg('Não foi possível selecionar este frete.');
    }
  },

  // Erro de select/close: alocação mudou (estoque, cd_id que não é mais do
  // carrinho) → mostra a mensagem e recalcula (no máx. 1x a cada 5s, pra
  // não entrar em laço se a API insistir no erro); outro erro → só a mensagem.
  _multiCdError(r) {
    const mod = wsMain.modules['cart-drawer'];
    const text = r?.message || 'Não foi possível selecionar este frete.';
    if (ApiWS.MultiCd.needsRecalc(r) && Date.now() - mod._multiCdRecalcAt > 5000) {
      mod._multiCdRecalcAt = Date.now();
      mod._reopenFrete(text);
      return;
    }
    mod._drawMultiCd();
    mod._multiCdMsg(text);
  },

  // Volta o cliente pro cálculo de frete (abre o bloco e recalcula com o CEP
  // salvo). Usado quando o carrinho muda num pedido Multi CD e nos erros de
  // alocação do /cart/close.
  async _reopenFrete(message) {
    const mod = wsMain.modules['cart-drawer'];
    mod._multiCd = null;
    mod._alterarFrete();
    const input = document.querySelector('[data-wsjs-cart="frete-cep"]');
    if (String(input?.value || '').replace(/\D/g, '').length === 8) await mod._calcularFrete();
    if (message) mod._multiCdMsg(message);
  },

  _alterarFrete() {
    const holder   = document.querySelector('[data-wsjs-cart="holder"]');
    const toggle   = holder.querySelector('[data-wsjs-cart="frete-toggle"]');
    const content  = holder.querySelector('[data-wsjs-cart="frete-content"]');
    const selected = holder.querySelector('[data-wsjs-cart="frete-selected"]');
    const cepInput = holder.querySelector('[data-wsjs-cart="frete-cep"]');

    wsMain.modules['cart-drawer']._lastSelectedFrete = null;
    wsMain.modules['cart-drawer']._freteEditing = true;
    if (selected) selected.style.display = 'none';
    if (toggle) {
      toggle.style.display = '';
      toggle.setAttribute('aria-expanded', 'true');
    }
    if (content) {
      content.style.removeProperty('display');
      content.classList.add('cd-expanded');
    }

    if (cepInput && !cepInput.value) {
      try {
        const savedCep = localStorage.getItem('CEP_CART_KEEP') || '';
        if (savedCep) cepInput.value = savedCep.replace(/(\d{5})(\d{3})/, '$1-$2');
      } catch (e) {}
    }
  },

  async _aplicarCupom() {
    const holder = document.querySelector('[data-wsjs-cart="holder"]');
    const input  = holder.querySelector('[data-wsjs-cart="cupom-input"]');
    const btn    = holder.querySelector('[data-wsjs-cart="cupom-aplicar"]');
    const msg    = holder.querySelector('[data-wsjs-cart="cupom-msg"]');
    const code   = (input?.value || '').trim();

    msg.style.display = 'none';

    if (!code) {
      msg.textContent = 'Digite o código do cupom.';
      msg.style.display = '';
      return;
    }

    btn.disabled = true;
    const originalLabel = btn.textContent;
    btn.textContent = 'Aplicando...';

    try {
      const result = await ApiWS.Calls.cartCouponApply(code);

      if (result?.result === 'success') {
        input.value = '';
        await wsMain.modules['cart-drawer'].get(true);
      } else {
        msg.innerHTML = ApiWS.Calls.cartCouponErrorHtml(result);
        msg.style.display = '';
        // "Clique aqui e faça seu login": fecha o carrinho lateral antes — a
        // sidebar de login (aberta pelo handler global de a[href="/login"])
        // entraria por baixo dele.
        msg.querySelector('[data-ws-coupon-login]')?.addEventListener('click', () => {
          wsMain.modules['cart-drawer']._saveCouponResume(code);
          try { if (document.querySelector('[data-wsjs-cart="button"]')?.getAttribute('cart-state') === 'true') wsMain.modules['cart-drawer'].changeState(); } catch (e) {}
        });
      }
    } catch (e) {
      console.error('[CartDrawer] aplicarCupom:', e);
      msg.textContent = 'Erro ao aplicar cupom.';
      msg.style.display = '';
    } finally {
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  },

  // Cupom que exige login: o link "Clique aqui" fecha o carrinho e abre a
  // sidebar de login, que recarrega a página ao autenticar (ou navega pra
  // /login, ou volta de um login social em página cheia). O código fica em
  // sessionStorage pra, na próxima página carregada já com o cliente logado,
  // o carrinho reabrir sozinho com o cupom reaplicado. Vale 10 min; enquanto
  // o cliente não logar, fica guardado.
  _saveCouponResume(code) {
    try { sessionStorage.setItem('ws_cart_coupon_resume', JSON.stringify({ code, ts: Date.now() })); } catch (e) {}
  },

  async _resumeCouponAfterLogin() {
    const mod = wsMain.modules['cart-drawer'];
    if (mod._couponResumeChecked) return;
    mod._couponResumeChecked = true;

    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('ws_cart_coupon_resume') || 'null'); } catch (e) {}
    if (!saved) return;

    const clear = () => { try { sessionStorage.removeItem('ws_cart_coupon_resume'); } catch (e) {} };
    if (!saved.ts || Date.now() - saved.ts > 10 * 60 * 1000) return clear();
    if (!ApiWS.User?.isValid?.()) return;

    const btn    = document.querySelector('[data-wsjs-cart="button"]');
    const holder = document.querySelector('[data-wsjs-cart="holder"]');
    if (!btn || !holder) return;
    clear();

    // Aplica antes de abrir: o changeState() abaixo já busca o /cart/view com
    // o cupom, e uma recusa (cupom não vale pra esse cliente) fica visível no
    // bloco do cupom, aberto aqui.
    try {
      const input  = holder.querySelector('[data-wsjs-cart="cupom-input"]');
      const toggle = holder.querySelector('[data-wsjs-cart="cupom-toggle"]');
      if (saved.code && input) {
        input.value = saved.code;
        if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
        await mod._aplicarCupom();
      }
    } catch (e) {
      console.error('[CartDrawer] resumeCoupon:', e);
    }

    if (btn.getAttribute('cart-state') !== 'true') mod.changeState();
  },

  async _removerCupom() {
    const msg = document.querySelector('[data-wsjs-cart="cupom-msg"]');
    try {
      await ApiWS.Calls.cartCouponRemove();
      await wsMain.modules['cart-drawer'].get(true);
    } catch (e) {
      console.error('[CartDrawer] removerCupom:', e);
      if (msg) {
        msg.textContent = 'Não foi possível remover o cupom.';
        msg.style.display = '';
      }
    }
  },

  /* O placeholder do drawer é injetado dentro de .cart-header, que por sua
     vez vive dentro de <header>. Mesmo com z-index alto, um elemento fixed
     aninhado assim fica preso ao stacking context do ancestral (o que quer
     que esteja criando esse context em <header>/.container/etc.) — por isso
     o z-index do .cart-holder nunca vencia o #overlay, que é filho direto
     do <body>. Movendo o holder pra ser filho direto do <body> também, ele
     passa a competir no MESMO stacking context raiz que o overlay, e aí sim
     o z-index (ver .cart-holder no CSS) decide. Só roda uma vez; não afeta
     o botão do carrinho nem o modo "float" (hover-preview), que continua
     dentro do header normalmente. */
  _moveDrawerToBody() {
    const holder = document.querySelector('[data-wsjs-cart="holder"]');
    if (!holder || holder.dataset.movedToBody) return;
    holder.dataset.movedToBody = '1';
    if (holder.parentElement !== document.body) {
      document.body.appendChild(holder);
    }
  },

  _showLoading() {
    const loading = document.querySelector('[data-wsjs-cart="loading"]');
    if (loading) loading.style.display = '';
  },

  _hideLoading() {
    const loading = document.querySelector('[data-wsjs-cart="loading"]');
    if (loading) loading.style.display = 'none';
  },

  // Widgets flutuantes (chat, "Ajuda pelo WhatsApp", "powerchat", etc.) usam
  // position:fixed com z-index às vezes maior que o do drawer (1001) — sem
  // controle nosso sobre esse valor, já que boa parte é CSS de terceiro ou
  // de outro módulo/tema, com !important. Em vez de perseguir cada widget
  // específico, varre TODOS os elementos do body ao abrir o carrinho (não só
  // os filhos diretos — o "Ajuda pelo WhatsApp" deste tema, por exemplo, é um
  // <a> nascido lá dentro do <footer>, ainda fixed via CSS mas bem aninhado
  // no DOM) e esconde (visibility, não display — sem tirar espaço/disparar
  // reflow) qualquer um fixed/absolute/sticky com z-index maior que o do
  // holder; devolve tudo ao fechar. setProperty(...,'important') garante que
  // ganha mesmo de um !important do próprio widget.
  _suppressOverlays() {
    if (this._suppressedOverlays) return;
    const holder = document.querySelector('[data-wsjs-cart="holder"]');
    if (!holder) return;
    const holderZ = parseInt(getComputedStyle(holder).zIndex, 10) || 0;
    const suppressed = [];
    document.body.querySelectorAll('*').forEach((el) => {
      if (el === holder || holder.contains(el)) return;
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'absolute' && cs.position !== 'sticky') return;
      const z = parseInt(cs.zIndex, 10);
      if (!Number.isFinite(z) || z <= holderZ) return;
      suppressed.push(el);
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
    this._suppressedOverlays = suppressed;
  },

  _restoreOverlays() {
    (this._suppressedOverlays || []).forEach((el) => {
      el.style.removeProperty('visibility');
      el.style.removeProperty('pointer-events');
    });
    this._suppressedOverlays = null;
  },

  changeState(force = false, onlyOpen = false) {
    const btn     = document.querySelector('[data-wsjs-cart="button"]');
    const state   = btn?.getAttribute('cart-state') === 'true';
    const opening = !state;
    // Ao abrir o drawer, busca os dados completos (/cart/view) para trazer
    // subtotal, desconto e cupom junto com os itens. Mostra o loading até
    // get() (que agora espera itens + sugestões + brindes + frete grátis,
    // ver refresh()) terminar de verdade, em vez do conteúdo ir aparecendo
    // aos poucos por cima do drawer já aberto.
    if (opening) {
      wsMain.modules['cart-drawer']._freteEditing = false;
      wsMain.modules['cart-drawer']._showLoading();
    }
    wsMain.modules['cart-drawer'].get(opening)
      // Abrir o carrinho lateral = view_cart no GA (igual ao legado). get(true) publica window.cartJson.
      .then(() => { if (opening) ApiWS.Analytics?.viewCart(window.cartJson); })
      .catch(e => console.error('[CartDrawer] get:', e))
      .finally(() => { if (opening) wsMain.modules['cart-drawer']._hideLoading(); });
    if (onlyOpen) return;

    const btnOptions = wsMain.tools.getWsData(btn, 'options');
    const cartHolder = document.querySelector('[data-wsjs-cart="holder"]');
    const overlay    = document.querySelector('[data-wsjs-cart="overlay-holder"]');
    const body       = document.querySelector('body');
    btn.setAttribute('cart-state', !state);

    if (btnOptions.mobile === true) {
      // Este ramo só mexia em `transform`, mas a posição-base do drawer (CSS
      // .cart-holder: position:fixed; right:-48rem) continua valendo por cima —
      // translateX(0) não tira o -48rem de `right`, então o drawer ficava
      // fechado (fora da tela) pra sempre, mesmo com os dados carregados certos
      // e a classe .active/transform aplicados. Alterna `right` junto, igual o
      // ramo desktop abaixo, pra realmente entrar na tela.
      if (state) {
        cartHolder.style.transform = 'translateX(100%)';
        cartHolder.style.right = '-48rem';
        cartHolder.classList.remove('active');
        wsMain.modules['cart-drawer']._restoreOverlays();
      } else {
        cartHolder.classList.add('active');
        cartHolder.style.right = '0';
        cartHolder.style.transform = 'translateX(0)';
        wsMain.modules['cart-drawer']._suppressOverlays();
      }
    } else {
      // O drawer flutua por cima do conteúdo (overlay) — não empurra mais o
      // body pro lado (removido: body.style.left = '-48rem').
      if (state || (force && !overlay.classList.contains('float'))) {
        body.style.overflow = '';
        cartHolder.style.right = '-48rem';
        cartHolder.classList.remove('active');
        overlay.setAttribute('style', 'width:0;height:0;opacity:0');
        wsMain.modules['cart-drawer']._restoreOverlays();
      } else {
        body.style.overflow = 'hidden';
        cartHolder.style.right = '0';
        cartHolder.classList.add('active');
        overlay.setAttribute('style', 'width:100%;height:100%;opacity:0.8');
        wsMain.modules['cart-drawer']._suppressOverlays();
      }
    }
  },

  /* ─────────────────────────────────────────────
     SIDEBAR "ADICIONADO AO CARRINHO" (estilo Mercado Livre)
     Aberta pelo botão "Adicionar" da página de produto (wsapi3-pag-prod-rules
     → openAddedToCartSidebar, que delega pra cá) e da listagem
     (wsapi3-prod-template-rules → afterFunction). NÃO é o carrinho lateral:
     é uma sidebar própria (#ws-added-sidebar) com aviso de item adicionado +
     foto/nome/qtd, linha "você tem mais X produtos no carrinho", recomendados
     (source=recommended do produto) e barra "Voltar para a loja" (botão) /
     "Ir para o carrinho" (botão cinza, que fecha esta e abre o carrinho
     lateral de verdade).

     Vive aqui (e não no pag-prod-rules) porque este módulo carrega em toda
     página — a listagem também precisa dela. Reaproveita 100% do CSS deste
     módulo (.cart-holder, .cd-scroll-area, .cart-item-*, .cd-suggestions*,
     .cd-suggestion-item*, [data-wsjs-cart="bottom-message"], .button-main,
     .cd-goto-cart-link, .cart-drawer-link-btn). Só #ws-added-sidebar.ws-open
     / .ws-added-overlay / .ws-added-more entram no CSS — abrir/fechar por
     classe (o carrinho de verdade usa `right` inline no JS, que colidiria
     com o [data-wsjs-cart="holder"]) e um overlay próprio (o #overlay do
     tema tem onclick fixo pro changeState). Nome/foto do item vêm do
     argumento `info` ou de window.__wsAddedProdInfo[productId] (preenchido
     por quem chama, ex. wsapi3-prod-template-rules na listagem).
  ───────────────────────────────────────────── */
  _addedRelatedCache: {},

  openAddedSidebar(productId, info = {}) {
    const mod = wsMain.modules['cart-drawer'];
    const pid = String(productId || info.productId || '');

    // info.items (array) = várias linhas entraram de uma vez (ex.: tabela de
    // sub-produtos da página de produto, cada linha com sua própria quantidade) —
    // ver wsapi3-pag-prod-rules.js/openAddedToCartSidebar. Sem isso, mantém o
    // comportamento de sempre: 1 item só (name/photo/qty, com os mesmos fallbacks
    // de antes).
    let items;
    if (Array.isArray(info.items) && info.items.length) {
      items = info.items.map(it => ({
        name: it.name || '',
        photo: it.photo || '',
        qty: Math.max(1, Number(it.qty || 1) || 1),
      }));
    } else {
      let stored = (window.__wsAddedProdInfo && window.__wsAddedProdInfo[pid]) || {};
      // Card que veio pronto do servidor (SSR) não passa pelo createProd() que preenche
      // __wsAddedProdInfo — lê nome/foto do próprio card da vitrine.
      if (!stored.name && !info.name) {
        const clicked = window.__wsListBuyCard;
        const card = clicked && clicked.isConnected && clicked.getAttribute('ws-prod-id') == pid
          ? clicked
          : document.querySelector('[ws-prod-id="' + pid + '"]');
        if (card) {
          stored = {
            name: card.querySelector('.prod-showcase-info-name')?.textContent.trim() || '',
            photo: card.querySelector('.prod-showcase-image img')?.currentSrc || card.querySelector('.prod-showcase-image img')?.getAttribute('src') || '',
          };
        }
      }
      // Quantidade que de fato foi pro carrinho (wsFuncBtBuyOnList / _wsFuncComprar gravam
      // antes de chamar aqui) — os inputs abaixo são só fallback: #TxtQtdAdd é o da página
      // de produto, e um card de "relacionados" com seletor de quantidade leria o errado.
      const lastAdded = (Array.isArray(window.__wsLastAddedItems) ? window.__wsLastAddedItems : [])
        .find(it => String(it.productId) === pid);
      items = [{
        name: info.name || stored.name || '',
        photo: info.photo || stored.photo || '',
        qty: Math.max(1, Number(
          info.qty ||
          lastAdded?.quantity ||
          document.querySelector('#TxtQtdAdd')?.value ||
          document.querySelector('#HD_QTD_PROD_' + pid)?.value ||
          1
        ) || 1),
      }];
    }
    // "Você tem mais X produtos" precisa da soma de tudo que entrou agora, não só
    // do 1º item — senão subtrai a quantidade errada do total do carrinho.
    const totalQty = items.reduce((soma, it) => soma + it.qty, 0);

    const sidebar = mod._buildAddedSidebar();
    mod._fillAddedItem(sidebar, { items });
    // Um /cart/preview só, compartilhado: "mais X produtos" e os recomendados
    // (que usam os produtos do carrinho inteiro, igual ao carrinho lateral).
    const previewP = ApiWS.Calls.carrinho().catch(e => { console.error('[cart-drawer] added preview:', e); return null; });
    mod._fillAddedMore(sidebar, totalQty, previewP);
    mod._fillAddedSuggestions(sidebar, pid, previewP);

    // Item acabou de entrar no carrinho — atualiza o contador do topo agora
    // (via /cart/preview), sem esperar o cliente abrir o carrinho lateral.
    // Fire-and-forget: o drawer está fora da tela, refresh() nele é invisível.
    mod.get(false).catch(e => console.error('[CartDrawer] openAddedSidebar refresh:', e));

    void sidebar.offsetWidth; // reflow p/ a transição de entrada rodar
    document.getElementById('ws-added-overlay')?.classList.add('ws-open');
    sidebar.classList.add('ws-open');
    document.body.style.overflow = 'hidden';
  },

  closeAddedSidebar() {
    document.getElementById('ws-added-sidebar')?.classList.remove('ws-open');
    document.getElementById('ws-added-overlay')?.classList.remove('ws-open');
    document.body.style.overflow = '';
  },

  _addedGoToCart() {
    wsMain.modules['cart-drawer'].closeAddedSidebar();
    try { wsMain.modules['cart-drawer'].changeState(); }
    catch (e) { window.location.href = '/carrinho'; }
  },

  _buildAddedSidebar() {
    let sidebar = document.getElementById('ws-added-sidebar');
    if (sidebar) return sidebar;

    const overlay = document.createElement('div');
    overlay.id = 'ws-added-overlay';
    overlay.className = 'ws-added-overlay';
    overlay.addEventListener('click', () => wsMain.modules['cart-drawer'].closeAddedSidebar());

    sidebar = document.createElement('div');
    sidebar.id = 'ws-added-sidebar';
    sidebar.className = 'cart-holder';
    sidebar.innerHTML = `
      <div class="cart-holder-header">
        <h2>
          <svg class="cd-header-title-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/><path d="M8 12.5l2.6 2.6L16 9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span>Adicionado ao carrinho</span>
        </h2>
        <div class="cd-header-actions">
          <button type="button" class="cd-plain-icon-btn" title="Fechar" aria-label="Fechar" data-added-close>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          </button>
        </div>
      </div>
      <div class="cd-scroll-area">
        <div class="cart-items-holder cartHasItens" data-added-item></div>
        <div class="ws-added-more" data-added-more style="display:none;">
          <span data-added-more-text></span>
          <a class="cart-drawer-link-btn" href="javascript:;" data-added-gotocart>Ver carrinho</a>
        </div>
        <div class="cd-suggestions" data-added-suggestions style="display:none;">
          <div class="cd-suggestions-title">
            <svg width="16" height="16" viewBox="0 0 12.979 12.979" fill="none"><path d="M2239.739,3428l-.746,2.99a3.793,3.793,0,0,1-.373,1.107,1.62,1.62,0,0,1-.522.522,3.805,3.805,0,0,1-1.108.373l-2.99.746,2.99.746a3.813,3.813,0,0,1,1.108.373,1.62,1.62,0,0,1,.522.522,3.793,3.793,0,0,1,.373,1.107l.746,2.99.746-2.99a3.793,3.793,0,0,1,.373-1.107,1.621,1.621,0,0,1,.522-.522,3.808,3.808,0,0,1,1.107-.373l2.99-.746-2.99-.746a3.8,3.8,0,0,1-1.107-.373,1.621,1.621,0,0,1-.522-.522,3.793,3.793,0,0,1-.373-1.107Z" transform="translate(-2233.25 -3427.25)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
            <span>Produtos recomendados</span>
          </div>
          <div class="cd-suggestions-list-wrap">
            <div class="cd-suggestions-list" data-added-suggestions-list></div>
          </div>
        </div>
      </div>
      <div class="cart-default-message" data-wsjs-cart="bottom-message">
        <a class="button-main" href="javascript:;" data-added-continue>Voltar para a loja</a>
        <a class="button-main cd-added-gotocart-btn" href="javascript:;" data-added-gotocart>Ir para o carrinho</a>
      </div>`;

    document.body.appendChild(overlay);
    document.body.appendChild(sidebar);

    sidebar.querySelector('[data-added-close]').addEventListener('click', () => wsMain.modules['cart-drawer'].closeAddedSidebar());
    sidebar.querySelector('[data-added-continue]').addEventListener('click', () => wsMain.modules['cart-drawer'].closeAddedSidebar());
    // "Ver carrinho" existe em dois lugares (linha "mais X produtos" e barra
    // inferior) — ambos fecham esta sidebar e abrem o carrinho lateral.
    sidebar.querySelectorAll('[data-added-gotocart]').forEach(el =>
      el.addEventListener('click', () => wsMain.modules['cart-drawer']._addedGoToCart()));

    if (!wsMain.modules['cart-drawer']._addedSidebarEsc) {
      wsMain.modules['cart-drawer']._addedSidebarEsc = true;
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.getElementById('ws-added-sidebar')?.classList.contains('ws-open')) {
          wsMain.modules['cart-drawer'].closeAddedSidebar();
        }
      });
    }

    return sidebar;
  },

  _fillAddedItem(sidebar, info) {
    const holder = sidebar.querySelector('[data-added-item]');
    if (!holder) return;
    // info.items (array) = várias linhas (ver openAddedSidebar) — 1 bloco
    // ".cart-item-holder" por item, igual ao que já existia pra 1 item só (que
    // continua funcionando: cai num array de 1 posição).
    const items = Array.isArray(info.items) && info.items.length ? info.items : [info];
    holder.innerHTML = items.map(item => {
      const nome = item.name || '';
      return `
      <div class="cart-item-holder">
        <span class="cd-added-item-photo">
          <span class="cart-item-img"><img src="${item.photo || ''}" alt="${nome.replace(/"/g, '&quot;')}" loading="lazy"></span>
          <span class="cd-added-item-check" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M8 12.5l2.6 2.6L16 9" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        </span>
        <div class="cart-item-body">
          <div class="cart-item-row-top">
            <span class="cart-item-name">${nome}</span>
          </div>
          <div class="cart-item-row-qty">
            <span class="cart-item-variation">Quantidade: ${item.qty}</span>
          </div>
        </div>
      </div>`;
    }).join('');
  },

  /* "Você possui mais X produtos no carrinho. Ver carrinho" — abaixo do item
     recém-adicionado, só quando o carrinho tem mais unidades além da
     quantidade que acabou de entrar. X = total de itens no carrinho menos a
     quantidade adicionada agora (cobre o caso do item já existir numa linha
     e só somar quantidade). */
  async _fillAddedMore(sidebar, addedQty, previewP) {
    const box = sidebar.querySelector('[data-added-more]');
    const txt = sidebar.querySelector('[data-added-more-text]');
    if (!box || !txt) return;
    box.style.display = 'none';

    const data = await (previewP || ApiWS.Calls.carrinho().catch(() => null));
    if (!data) return;

    const list = data?.products || data?.records || [];
    const totalItems = Number(
      data?.qtdItems ??
      data?.record?.item_count ??
      list.reduce((s, p) => s + (Number(p.qtd ?? p.quantity) || 0), 0)
    ) || 0;

    const rest = totalItems - (Number(addedQty) || 0);
    if (rest <= 0) return;

    txt.textContent = `Você possui mais ${rest} ${rest === 1 ? 'produto' : 'produtos'} no carrinho. `;
    box.style.display = '';
  },

  // Recomendados = source=recommended do produto recém-adicionado + dos demais
  // produtos do carrinho (mesma base do carrinho lateral, ApiWS.Calls.listProducts
  // .suggestion). Antes só o produto adicionado entrava na consulta — e como
  // muitos produtos não têm recomendados próprios, a lista vinha vazia aqui
  // enquanto o carrinho lateral (que consulta o carrinho inteiro) mostrava.
  async _fillAddedSuggestions(sidebar, productId, previewP) {
    const section = sidebar.querySelector('[data-added-suggestions]');
    const list = sidebar.querySelector('[data-added-suggestions-list]');
    if (!section || !list) return;

    const preview = await (previewP || Promise.resolve(null));
    const cartIds = (preview?.records || [])
      .map(p => p.product_master_id || p.product_id)
      .filter(Boolean)
      .map(String);
    const ids = [...new Set([String(productId || ''), ...cartIds].filter(Boolean))].join(',');
    if (!ids) { section.style.display = 'none'; return; }

    const mod = wsMain.modules['cart-drawer'];
    mod._addedRelatedCache = mod._addedRelatedCache || {};
    let products = mod._addedRelatedCache[ids];
    if (!products) {
      try {
        const raw = await ApiWS.Calls._get('/product/list', { source: 'recommended', product_id: ids });
        products = ApiWS.Calls.normalize.productList(raw)?.produtos || [];
      } catch (e) {
        console.error('[cart-drawer] added suggestions:', e);
        products = [];
      }
      mod._addedRelatedCache[ids] = products;
    }

    if (!Array.isArray(products) || !products.length) {
      section.style.display = 'none';
      return;
    }

    list.innerHTML = products.slice(0, 6).map(p => {
      const foto = Array.isArray(p.fotos) ? (typeof p.fotos[0] === 'string' ? p.fotos[0] : p.fotos[0]?.normal || '') : '';
      const url = p.links?.ver_produto || '#';
      return `
        <div class="cd-suggestion-item" data-product-id="${p.id}">
          <a href="${url}" class="cd-suggestion-item__img"><img src="${foto}" alt="${(p.nome || '').replace(/"/g, '&quot;')}" loading="lazy"></a>
          <div class="cd-suggestion-item__info">
            <a href="${url}" class="cd-suggestion-item__name">${p.nome || ''}</a>
            <div class="cd-suggestion-item__prices cd-price-block">${wsMain.modules['cart-drawer']._suggestionPriceHtml(p)}</div>
            <button type="button" class="cart-drawer-link-btn" data-action="add-suggestion">Adicionar ao carrinho</button>
          </div>
        </div>`;
    }).join('');
    section.style.display = '';

    // "Adicionar ao carrinho" dos recomendados — mesma ação do handler de
    // _renderSuggestions, mas aqui a sidebar "Adicionado" continua aberta
    // (modo "continuar comprando"), então só damos feedback no botão e um
    // get(false) leve pra atualizar o contador do carrinho — sem o /cart/view
    // completo nem re-render das sugestões/brindes do drawer escondido atrás.
    if (!list.dataset.bound) {
      list.dataset.bound = '1';
      list.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-action="add-suggestion"]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        const productId = btn.closest('[data-product-id]')?.dataset.productId;
        if (!productId) return;

        btn.disabled = true;
        const originalLabel = btn.textContent;
        btn.textContent = 'Adicionando...';
        try {
          const result = await ApiWS.Calls.cartAddItem({ productId, quantity: 1 });
          if (wsMain.modules['cart-drawer']._redirectIfNeedsSelection(result, btn.closest('[data-product-id]'))) return;
          await wsMain.modules['cart-drawer'].get(false);
          btn.textContent = 'Adicionado ✓';
        } catch (err) {
          console.error('[cart-drawer] added-sidebar addSuggestion:', err);
          btn.disabled = false;
          btn.textContent = originalLabel;
        }
      });
    }
  }
});
